import { getBaseRole } from '@/helpers/customRoles';
import { getAdditionalTeacherNames } from '@/helpers/additionalTeacherNames'
import { useAddAlert } from '@/hooks/useAddAlert'
import { selectProfile } from '@store/profile.reducer'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import iclasses from '@pages/Admin/CRM/styles/input.module.css'
import jclasses from '@pages/Admin/CRM/styles/jsmodal.module.css'
import classes from './index.module.css'
import bodyModalClasses from '@common/ProfileCard/BodyModal/BodyModal.module.css'
import { getDocumentDisplayName } from '@pages/Admin/Requests/requests.utils'
import { useEffect, useRef, useState } from 'react'
import {
  EditIcoNewDesign,
  IcoEdit,
  IconDone,
  IcoRemove,
} from '@/utils/icons'
import Preloader from '@UI/Preloader'
import {
  classApi,
  courseAPI,
  departments,
  directionOrdersApi,
  directionGroupApi,
  massActionsApi,
  profileFieldsApi,
  referralProgramApi,
  usersAPI,
} from '@/api'
import { getAvatar } from '@/helpers/getAvatar'
import Button from '@UI/Button'
import ButtonNew from '@UI/New/Button'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import Text from '@UI/New/Text'
import Modal, { ModalContainer } from '@common/Modal'
import { BodyModal } from '@common/ProfileCard/BodyModal/BodyModal'
import { DatePicker, Input, InputNumber, Tabs } from 'antd'
import dayjs from 'dayjs'
import { AuthService } from '@/services/AuthService'
import Moment from 'react-moment'
import ModalRemoveClass from '@common/ProfileCard/BodyEdit/ModalRemoveClass'
import { Tooltip } from 'antd'
import ModalRecoverPassword from '../../Colleges/modals/ModalRecoverPassword'
import ActionModal from '../ActionModal'
import BlockStudentModal from '../BlockStudentModal'
import SelectDepartmentModal from '../SelectDepartmentModal'
import {
  CopyOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'
import { Select as SelectAnt, Modal as ModalAnt } from 'antd'
import { useAsyncFn } from 'react-use'
import { isError } from '@/helpers/checkQuery'
import UserSearch from '../../components/UserSearch'
import UserBlock from '../../components/UserBlock'
import {
  OpenLeadProfileTab,
  CreateLeadProfileTab,
} from './components/LeadProfileTab/LeadProfileTab'
import FinancialTransactionsReportModal from '@UI/TablePaymentsDiscounts/components/FinancialTransactionsReportModal/FinancialTransactionsReportModal'
import StudentBilling from '@common/StudentBilling/StudentBilling'
import GoalsList from '@common/Goals/GoalsList'
import NotesList from '@common/Notes/NotesList'
import EmailVerifyWrapper from '@common/EmailVerifyWrapper/EmailVerifyWrapper'
import { declOfNum } from '@/helpers/declOfNum'
import { getCorrectFilePath } from '@/helpers/new/getCorrectFilePath'
import { getApiErrorMessage } from '@/helpers/getApiErrorMessage'
import { ensureApiSuccess } from '@/helpers/ensureApiSuccess'
import HorizontalProfileQRCard from '@UI/ProfileQRCard/HorizontalProfileQRCard'
import { GamificationBalanceCell, LVLCell } from '../../StudentsTable'
import StudentChatsTab from '@pages/Admin/AllUsers/modals/EditStudentModal/components/StudentChatsTab/StudentChatsTab'
import ExtendTraining from '@pages/Admin/Reports/ContinuingEducation/modal'
import FranchiseSelect from '@common/FranchiseSelect/FranchiseSelect'
import AddContractModal from '../AddContractModal/AddContractModal'
import AddTemplateContractModal from '../AddContractModal/AddTemplateContractModal'
import LessonStatusesTab from './components/LessonStatusesTab/LessonStatusesTab'
import StudentLearningDynamics from './components/StudentLearningDynamics'
import StudentDepartmentsAndContractsTab from './components/StudentContractsTab'
import PurposePaymentsTab from './components/PurposePaymentsTab/PurposePaymentsTab'
import {
  STUDENT_FIELD_TYPES,
  STUDENT_AGE_INPUT_TOOLTIP,
  STUDENT_PARENT_FIELDS,
  getStudentFieldDefaultActive,
  getStudentCustomFieldValues,
  getStudentProfileFields,
  isStudentProfileFieldVisibleForRole,
  isStudentProfileTeacherRole,
  isTextareaStudentField,
  isValidStudentLinkValue,
} from '@/helpers/studentProfileFields'
import { getAgeFromBirthDate } from '@/helpers/date'
import {
  PROFILE_FIELD_ENTITY_TYPES,
  getProfileFieldValue,
  getProfileFieldValuesPayload,
  getProfileFieldValuesResponseData,
  getProfileFieldsResponseData,
  setProfileFieldValue,
} from '@/helpers/profileFields'
import NotificationsSettingsButton from '@modals/NotificationsSettings/NotificationsSettingsButton'
import CourseAdditionalTeachersModal from './components/CourseAdditionalTeachersModal'
import DemoPeriodBadge from '@UI/New/DemoPeriodBadge'
import { getCourseDemoPeriodInfo } from '@/helpers/courseDemoPeriod'
import NewCourseBadge from '@UI/New/NewCourseBadge'
import StudentCourseIndicators from '@UI/New/StudentCourseIndicators'

const getStudentCardLink = (studentId) => {
  if (!studentId || typeof window === 'undefined') return ''

  const url = new URL('/users/students', window.location.origin)
  url.searchParams.set('student_id', String(studentId))

  return url.toString()
}

const getPaymentWithoutRegistrationLink = (studentId) => {
  if (!studentId || typeof window === 'undefined') return ''

  const url = new URL('/payment-without-registration', window.location.origin)
  url.searchParams.set('search', String(studentId))

  return url.toString()
}

const getPaymentWithoutRegistrationOrderLink = (studentId, orderId) => {
  if (!studentId || !orderId || typeof window === 'undefined') return ''

  const url = new URL('/payment-without-registration', window.location.origin)
  url.searchParams.set('search', String(studentId))
  url.searchParams.set('orderId', String(orderId))

  return url.toString()
}

const getPaymentWithoutRegistrationClassLink = (studentId, classId) => {
  if (!studentId || !classId || typeof window === 'undefined') return ''

  const url = new URL('/payment-without-registration', window.location.origin)
  url.searchParams.set('search', String(studentId))
  url.searchParams.set('classId', String(classId))

  return url.toString()
}

const normalizeStudentBalances = (value) => {
  let rows = []

  try {
    rows = typeof value === 'string' ? JSON.parse(value) : value
  } catch (e) {
    rows = []
  }

  if (!Array.isArray(rows) || rows.length === 0) {
    return [{ id: '0', name: 'Доп. активности' }]
  }

  return rows
    .map((row, index) => {
      const id = String(row?.id ?? row?.balanceId ?? index)
      const name = String(row?.name ?? '').trim()

      return {
        id: id || String(index),
        name: name || `Баланс ${index + 1}`,
      }
    })
    .filter((row) => row.name)
}

const formatRub = (value) => {
  const amount = Number(value ?? 0)

  return `${Number.isFinite(amount) ? amount.toLocaleString('ru-RU') : 0} ₽`
}
const GAMIFICATION_EXPERIENCE_TOOLTIP =
  'Опыт учащегося. В этом поле вводится количество опыта.'
const GAMIFICATION_BALANCE_TOOLTIP =
  'Игровая валюта учащегося. В этом поле вводится количество валюты.'

const PaymentWithoutRegistrationLinkField = ({ link = '' }) => {
  if (!link) return null

  return (
    <Text
      type="lightGray"
      className={classes.paymentWithoutRegistrationItemLink}
      texts={[link]}
      copy={{
        show: true,
        copyText: 'Ссылка на продление обучения скопирована',
      }}
    />
  )
}

const PaymentWithoutRegistrationDescription = ({
  link = '',
  title = 'Ссылка на продление обучения',
  additionalClass,
  showTitle = true,
}) => {
  if (!link) return null

  return (
    <div
      className={classNames(
        classes.directionDescriptionWrapper,
        additionalClass,
      )}
    >
      {showTitle && <div className={classes.directionDescriptionTitle}>{title}</div>}
      <PaymentWithoutRegistrationLinkField link={link} />
    </div>
  )
}

const StudentDirectionsTableCell = ({ label, children, className }) => (
  <div className={classNames(classes.studentDirectionsTableCell, className)}>
    <div className={classes.studentDirectionsMobileLabel}>{label}</div>
    {children}
  </div>
)

const StudentDirectionsStatus = ({ children, type = 'default' }) => (
  <span
    className={classNames(
      classes.studentDirectionsStatus,
      type === 'alert' && classes.studentDirectionsStatusAlert,
      type === 'success' && classes.studentDirectionsStatusSuccess,
    )}
  >
    {children}
  </span>
)

const StudentDirectionsHeaderCell = ({ children, tooltip }) => (
  <Tooltip title={tooltip} placement="top">
    <div className={classes.studentDirectionsTableHeaderCell}>{children}</div>
  </Tooltip>
)

const copyToClipboard = async (text) => {
  if (typeof navigator !== 'undefined' && navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
    return
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

const EditStudentModal = (props) => {
  return (
    <div className={classes.modalContainer}>
      <StudentProfileContainer {...props} />
    </div>
  )
}

const StudentProfileContainer = ({
  studentId = null,
  onDismiss = () => {},
  onUpdate = () => {},
  onClickByParent = () => {},
  onClickByLead = () => {},
  onClickByTeacher = () => {},
}) => {
  const addAlert = useAddAlert()
  const profile = useSelector(selectProfile)
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [user, setUser] = useState({})
  const [childrenDirection, setChildrenDirection] = useState([])
  const [userOld, setUserOld] = useState({})
  const [bodyModal, setBodyModal] = useState(null)
  const [actionModal, setActionModal] = useState(null)
  const [recoverPasswordModal, setRecoverPasswordModal] = useState(false)
  const platformSettings = useSelector(store => store.settings)
  const [customProfileFields, setCustomProfileFields] = useState([])
  const canViewFinancialData = !isStudentProfileTeacherRole(profile?.role)
  const [ktpGroupSelections, setKtpGroupSelections] = useState([])
  const [isKtpGroupSelectionsLoading, setIsKtpGroupSelectionsLoading] =
    useState(canViewFinancialData)
  const [isKtpGroupSelectionsRefreshing, setIsKtpGroupSelectionsRefreshing] =
    useState(false)
  const ktpGroupSelectionsRequestIdRef = useRef(0)
  const [showKtpGroupSelectionErrors, setShowKtpGroupSelectionErrors] =
    useState(false)

  const constDataModal = {
    state: user,
    setState: setUser,
    close: () => setBodyModal(null),
    setBodyModal,
    addAlert,
  }

  const params = [
    'name',
    'login',
    'email',
    'phone',
    'sex',
    'birth_date',
    'city',
    'address',
    'education',
    'experience',
    'custom_id',
    'promo_code',
    'link_to_vk',
    'password',
    'about',
    'notes',
    'about_student',
    'parent_name',
    'parent_phone',
    'parent_telegram',
    'parent_email',
    'parent_whatsapp',
    'roles',
    'learning_class',
    'age',
    'timezone',
    'url_conference',
    'seminarianDirection',
    'update_vks',
    'parents',
    'franchise_ids',
    'custom_fields',
  ]

  const save = async () => {
    if (isKtpGroupSelectionsLoading || isKtpGroupSelectionsRefreshing) {
      addAlert({
        type: 'error',
        title: 'Дождитесь обновления групп КТП',
      })
      return
    }

    const profileFields = getStudentProfileFields(
      platformSettings,
      customProfileFields,
    )
    const customFieldValues = getStudentCustomFieldValues(user)
    const getFieldValue = (field) => {
      if (field.isCustom) return getProfileFieldValue(customFieldValues, field)
      if (field.id === 'age') return getAgeFromBirthDate(user.birth_date)
      return user[field.valueKey]
    }
    const emptyRequiredField = profileFields.find((field) => {
      if (!field.required || (!field.valueKey && !field.isCustom)) return false
      const value = getFieldValue(field)
      return value === undefined || value === null || String(value).trim() === ''
    })
    const invalidLinkField = profileFields.find((field) => {
      if (field.type !== STUDENT_FIELD_TYPES.LINK) return false
      const value = getFieldValue(field)
      return value && !isValidStudentLinkValue(value)
    })

    if (emptyRequiredField) {
      addAlert({
        type: 'error',
        title: 'Заполните обязательное поле',
        text: emptyRequiredField.label,
      })
      return
    }

    if (invalidLinkField) {
      addAlert({
        type: 'error',
        title: 'Некорректная ссылка',
        text: invalidLinkField.label,
      })
      return
    }

    const missingKtpGroupSelection = ktpGroupSelections.find(
      (selection) =>
        selection.groups.length > 1 &&
        selection.selection_required &&
        !selection.groups.some(
          (group) => group.group_id === selection.group_id,
        ),
    )

    if (missingKtpGroupSelection) {
      setShowKtpGroupSelectionErrors(true)
      addAlert({
        type: 'error',
        title: 'Выберите группу КТП',
        text: `Для курса «${missingKtpGroupSelection.direction_name}» выберите одну группу КТП.`,
      })
      return
    }

    setShowKtpGroupSelectionErrors(false)

    setIsLoading(true)
    const data = () => {
      const newData = {}

      for (let key in user) {
        if (params.includes(key)) {
          if (typeof user[key] === 'string') {
            if (user[key]?.length === 0) newData[key] = null
            else newData[key] = user[key]
          } else {
            newData[key] = user[key]
          }
          if (key === 'custom_id' && userOld[key] && !user[key])
            newData[key] = null
          if (key === 'parents')
            newData[key] = user[key]?.map((child) => child.id)
        }
        if (key === 'birth_date' && user[key]) {
          newData[key] = user[key].replace(/\./g, '-')
        }
      }
      newData.age = getAgeFromBirthDate(user.birth_date)
      if ('custom_fields' in user) {
        newData.custom_fields = JSON.stringify(getStudentCustomFieldValues(user))
      }
      const changedKtpGroupSelections = ktpGroupSelections
        .filter(
          (selection) =>
            selection.groups.length > 1 &&
            selection.group_id !== null &&
            selection.group_id !== undefined &&
            selection.group_id !== selection.initial_group_id,
        )
        .map((selection) => ({
          direction_id: selection.direction_id,
          group_id: selection.group_id,
        }))

      if (changedKtpGroupSelections.length > 0) {
        newData.ktp_group_selections = changedKtpGroupSelections
      }
      return newData
    }

    const customFieldsPayload = getProfileFieldValuesPayload(
      profileFields.filter((field) => field.isCustom),
      customFieldValues,
    )

    return usersAPI.upd(
      { id: user.id, data: data() },
      { skipGlobalErrorAlert: true },
    ).then(async (res) => {
      const responseData = res?.data ?? res?.response?.data

      if (responseData?.status === 'success') {
        setKtpGroupSelections((selections) =>
          selections.map((selection) => ({
            ...selection,
            initial_group_id: selection.group_id,
          })),
        )
        if ('custom_fields' in user) {
          try {
            const valuesResponse = await profileFieldsApi.saveValues({
              user_id: user.id,
              entity_type: PROFILE_FIELD_ENTITY_TYPES.STUDENT,
              custom_fields: customFieldsPayload,
            })
            setUser((prevProfile) => ({
              ...prevProfile,
              custom_fields: getProfileFieldValuesResponseData(valuesResponse),
            }))
          } catch {
            addAlert({
              type: 'error',
              title: 'Ошибка сохранения дополнительных полей',
            })
          }
        }
        addAlert({ title: 'Профиль изменен' })
        onUpdate()
        return true
      } else {
        const responseError = responseData?.error
        addAlert({
          type: 'error',
          title: 'Упс! Ошибка',
          text:
            (Array.isArray(responseError)
              ? responseError[0]
              : typeof responseError === 'string'
                ? responseError
                : null) ??
            getApiErrorMessage(
              res,
              'Попробуйте ещё раз или обратитесь к администратору',
            ),
        })
        return false
      }
    }).catch((error) => {
      addAlert({
        type: 'error',
        title: 'Упс! Ошибка',
        text: getApiErrorMessage(error, 'Попробуйте ещё раз или обратитесь к администратору'),
      })
      return false
    }).finally(() => {
      setIsLoading(false)
    })
  }

  const getUser = (withLoader = true) => {
    setIsLoading(withLoader)
    return usersAPI
      .getUser({
        id: studentId,
        expand: [
          'userProfile',
          'roles',
          'contracts',
          'workHours',
          'parents',
          'orgUnits.head',
          'teams.head',
          'crmLead',
          'documents',
          'documents_compliance',
        ],
        role: 'children',
      })
      .then(async (res) => {
        const data = {}
        if (res.data?.id !== undefined)
          for (let key in res.data) {
            if (key === 'userProfile')
              for (let y in res.data.userProfile)
                data[y] = res.data.userProfile[y]
            else data[key] = res.data[key]
          }
        try {
          const valuesResponse = await profileFieldsApi.values({
            user_id: studentId,
            entity_type: PROFILE_FIELD_ENTITY_TYPES.STUDENT,
          })
          data.custom_fields = getProfileFieldValuesResponseData(valuesResponse)
        } catch {}
        setUser(data)
        setUserOld(data)
        setIsLoading(false)
      })
  }

  const getDirection = () => {
    return directionOrdersApi
      .get({
        filter: [`[children_id][eq]=${studentId}`, `[is_disabled][eq]=0`],
        includeBlocked: true,
        expand: [
          'direction',
          'tariff',
          'tariff.tariffPeriods',
          'tariff.tariffDays',
          'tariff.tariffWeeks',
          'direction.directionTariffs',
          'direction.directionTariffs.tariffPeriods',
          'direction.directionTariffs.tariffDays',
          'direction.directionTariffs.tariffWeeks',
          'group.teacher',
          'group.additionalTeachers',
          'group.temporaryAdditionalTeachers',
          'privateInfo',
          'teacher',
          'additionalTeachers',
          'temporaryAdditionalTeachers',
          'direction.mediaIcon',
        ],
        pageSize: false,
      })
      .then((res) => {
        const directions = (res.data?.data || []).map((direction) =>
          direction.teacher_id
            ? direction
            : { ...direction, teacher: direction.group },
        )

        setChildrenDirection(directions)
      })
  }

  const getKtpGroupSelections = ({ preserveChanges = false } = {}) => {
    if (!canViewFinancialData) {
      setIsKtpGroupSelectionsLoading(false)
      return
    }

    const requestId = ++ktpGroupSelectionsRequestIdRef.current
    if (preserveChanges) {
      setIsKtpGroupSelectionsRefreshing(true)
    } else {
      setIsKtpGroupSelectionsLoading(true)
    }
    return directionOrdersApi
      .getKtpGroupSelections(studentId)
      .then(ensureApiSuccess)
      .then((response) => {
        if (requestId !== ktpGroupSelectionsRequestIdRef.current) return

        const selections = Array.isArray(response?.data?.data)
          ? response.data.data
          : []

        setKtpGroupSelections((previousSelections) =>
          selections.map((selection) => {
            const groups = Array.isArray(selection.groups)
              ? selection.groups
              : []
            const initialGroupId =
              selection.selected_group_id ?? selection.effective_group_id
            const hasInitialGroup = groups.some(
              (group) => group.group_id === initialGroupId,
            )
            const previousSelection = previousSelections.find(
              (item) => Number(item.direction_id) === Number(selection.direction_id),
            )
            const hasPendingSelection =
              preserveChanges &&
              previousSelection?.group_id !== previousSelection?.initial_group_id &&
              groups.some((group) => group.group_id === previousSelection?.group_id)

            return {
              ...selection,
              groups,
              initial_group_id: hasInitialGroup ? initialGroupId : null,
              group_id: hasPendingSelection
                ? previousSelection.group_id
                : hasInitialGroup ? initialGroupId : null,
            }
          }),
        )
      })
      .catch(() => {
        if (requestId !== ktpGroupSelectionsRequestIdRef.current) return

        if (preserveChanges) {
          addAlert({
            type: 'error',
            title: 'Не удалось обновить группы КТП',
            text: 'Обновите карточку учащегося и повторите попытку.',
          })
        } else {
          setKtpGroupSelections([])
        }
      })
      .finally(() => {
        if (requestId !== ktpGroupSelectionsRequestIdRef.current) return

        setIsKtpGroupSelectionsLoading(false)
        setIsKtpGroupSelectionsRefreshing(false)
      })
  }

  const changeKtpGroupSelection = (directionId, groupId) => {
    setKtpGroupSelections((selections) =>
      selections.map((selection) =>
        Number(selection.direction_id) === Number(directionId)
          ? { ...selection, group_id: groupId }
          : selection,
      ),
    )
  }

  const getCustomProfileFields = () => {
    profileFieldsApi
      .index({ entity_type: PROFILE_FIELD_ENTITY_TYPES.STUDENT })
      .then((response) => {
        setCustomProfileFields(getProfileFieldsResponseData(response))
      })
  }

  useEffect(() => {
    getUser()
    getDirection()
    getKtpGroupSelections()
    getCustomProfileFields()

    return () => {
      ktpGroupSelectionsRequestIdRef.current += 1
    }
  }, [])

  const authorization = async () => {
    try {
      const response = await usersAPI.authorization(user.id)

      if(response?.data?.user?.id){
        AuthService.auth(
          response.data.user,
          response.data.token,
          response.data?.refresh_token,
        )
        window.location.href = '/'
      } else {
        addAlert({ title: 'Ошибка', text: 'При входе в ЛК произошла ошибка', type: 'error' })
      }
    } catch (error) {
      addAlert({
        title: 'Ошибка',
        text: getApiErrorMessage(error, 'При входе в ЛК произошла ошибка'),
        type: 'error',
      })
    }
  }

  const changeUserStatus = (status, alert, removeCourses = false) => {
    // const courses = childrenDirection?.filter(({class_id}) => !class_id) ?? []

    // if(courses?.length > 0){
    //   addAlert({ title: "Нельзя удалить учащегося с активными курсами!", type: 'error' });
    //   return
    // }

    const data = new FormData()
    data.append('ids', JSON.stringify([user.id]))
    data.append('status', status)
    if (status === 0) data.append('remove_courses', removeCourses ? '1' : '0')
    if (status === 9) data.append('role', 'children')

    const handleResponse = (res) => {
      if (res.data.status !== 'success') {
        addAlert({
          title: 'Ошибка',
          text: 'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
          type: 'error',
        })
        return false
      } else {
        const isStudentRoleRemoved = res.data?.data?.processed?.some(
          (item) => item.id === user.id && getBaseRole(item.role_removed) === 'children',
        )

        if (isStudentRoleRemoved) {
          addAlert({ title: 'Роль учащегося удалена' })
          onUpdate()
          onDismiss()
          return
        }

        addAlert({ title: alert })
        setUser((prevProfile) => ({
          ...prevProfile,
          status: status,
        }))
        onUpdate()
        getDirection()
        return true
      }
    }

    const handleError = (error) => {
      addAlert({
        title: 'Ошибка',
        text: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
        type: 'error',
      })
    }

    return massActionsApi
      .changeStatus(data)
      .then((res) => handleResponse(res))
      .catch(handleError)
  }

  const handleFooterAction = (action) => {
    switch (action) {
      case 'save':
        save()
        break
      case 'cancel':
        onDismiss()
        break
      case 'resetPassword':
        setRecoverPasswordModal(true)
        //setBodyModal({ type: 'ChangePassword' })
        break
      case 'authorize':
        authorization()
        break
      case 'block':
        setActionModal({
          type: user?.status === 0 ? 'unblock' : 'block',
          title: 'Подтвердите действие',
          content: `Вы уверены что хотите ${user?.status === 0 ? 'разблокировать' : 'заблокировать'} ${
            user?.name ?? 'учащегося'
          }?`,
          onConfirm: async (removeCourses = false) => {
            const success = await changeUserStatus(
              user?.status === 0 ? 10 : 0,
              user?.status === 0
                ? 'Учащийся восстановлен'
                : 'Учащийся заблокирован',
              removeCourses,
            )
            if (success) setActionModal(null)
          },
          onDismiss: () => setActionModal(null),
        })
        break
      case 'delete':
        setActionModal({
          title: 'Подтвердите действие',
          content: `Вы уверены что хотите удалить ${
            user?.name ?? 'учащегося'
          }?`,
          onConfirm: () =>
            changeUserStatus(
              user?.status === 9 ? 10 : 9,
              user?.status === 9 ? 'Учащийся восстановлен' : 'Учащийся удален',
            ),
          onDismiss: () => setActionModal(null),
        })
        break
      default:
        console.log('Unknown action')
    }
  }

  if (isLoading || isKtpGroupSelectionsLoading) {
    return (
      <div className={classes.preloaderContainer}>
        <Preloader fullScreen="center" />
      </div>
    )
  }

  return (
    <>
      <div className={classes.studentContentWrapper}>
        <StudentProfileHeader
          platformSettings={platformSettings}
          student={{ ...user, childrenDirection }}
          setUser={setUser}
          setModal={setBodyModal}
          canViewFinancialData={canViewFinancialData}
        />
        <StudentProfileBody
          platformSettings={platformSettings}
          customProfileFields={customProfileFields}
          student={{ ...user, childrenDirection }}
          setUser={setUser}
          setModal={setBodyModal}
          getDirection={getDirection}
          getUser={getUser}
          onClickByParent={onClickByParent}
          onClickByLead={onClickByLead}
          onClickByTeacher={onClickByTeacher}
          onSave={save}
          canViewFinancialData={canViewFinancialData}
          ktpGroupSelections={ktpGroupSelections}
          onKtpGroupSelectionChange={changeKtpGroupSelection}
          showKtpGroupSelectionErrors={showKtpGroupSelectionErrors}
        />
        <StudentProfileFooter
          student={user}
          onAction={handleFooterAction}
          canEdit={canViewFinancialData}
        />
      </div>
      {bodyModal?.type === 'AddContract' && (
        <AddContractModal
          close={() => setBodyModal(null)}
          state={user}
          setState={setUser}
        />
      )}
      {bodyModal?.type === 'AddTemplateContract' && (
        <AddTemplateContractModal
          close={() => setBodyModal(null)}
          state={user}
          setState={setUser}
        />
      )}
      <Modal
        active={
          bodyModal != null &&
          bodyModal?.type !== 'AddContract' &&
          bodyModal?.type !== 'AddTemplateContract'
        }
        className={classNames(
          classes.modalWrapperOld,
          (bodyModal?.type === 'AddDirection' ||
            bodyModal?.type === 'AddGroupToClass') &&
            classes.addDirectionModal,
        )}
        setActive={() => {
          if (!bodyModal?.disableClose) {
            setBodyModal(null)
          }
        }}
        classNameBackground={classes.modalBackground}
      >
        {bodyModal?.type === 'ExtendTraining' ? (
          <ExtendTraining
            data={bodyModal.data}
            setState={bodyModal.onSuccess ?? (() => getDirection())}
            closeModal={() => setBodyModal(null)}
            enableBalanceInputMode
          />
        ) : (
          <BodyModal
            {...bodyModal}
            {...constDataModal}
            data={
              ['AddClass', 'AddGroupToClass'].includes(bodyModal?.type)
                ? {
                    ...bodyModal.data,
                    onSuccess: (...args) => {
                      bodyModal.data?.onSuccess?.(...args)
                      getKtpGroupSelections({ preserveChanges: true })
                    },
                  }
                : bodyModal?.data
            }
            getDirection={() => {
              getDirection()
              if (bodyModal?.type === 'AddDirection') {
                getKtpGroupSelections({ preserveChanges: true })
              }
            }}
          />
        )}
      </Modal>
      <Modal
        active={recoverPasswordModal}
        setActive={() => setRecoverPasswordModal(false)}
      >
        {recoverPasswordModal && (
          <ModalContainer closeModal={() => setRecoverPasswordModal(false)}>
            <ModalRecoverPassword
              setActive={() => setRecoverPasswordModal(false)}
              userId={user.id}
            />
          </ModalContainer>
        )}
      </Modal>
      <Modal
        active={actionModal !== null}
        setActive={() => setActionModal(null)}
        className={classes.modalWrapper}
      >
        {actionModal?.type === 'block' ? (
          <BlockStudentModal
            title={actionModal.title}
            content={actionModal.content}
            onDismiss={actionModal.onDismiss}
            onConfirm={actionModal.onConfirm}
          />
        ) : (
          <ActionModal
            title={actionModal?.title}
            content={actionModal?.content}
            onDismiss={actionModal?.onDismiss}
            onAction={actionModal?.onConfirm}
          />
        )}
      </Modal>
    </>
  )
}

const StudentProfileBody = ({
  platformSettings = {},
  customProfileFields = [],
  student = {},
  setUser = () => {},
  setModal = () => {},
  getDirection = () => {},
  getUser = () => {},
  onClickByParent = () => {},
  onClickByLead = () => {},
  onClickByTeacher = () => {},
  onSave = null,
  canViewFinancialData = true,
  ktpGroupSelections = [],
  onKtpGroupSelectionChange = () => {},
  showKtpGroupSelectionErrors = false,
}) => {
  const [lessonStatusesRevision, setLessonStatusesRevision] = useState(0)
  const profile = useSelector(selectProfile)
  const canManageBilling = ['admin', 'junior-admin'].includes(getBaseRole(profile?.role))
  const tabItems = [
    {
      label: 'Об учащемся',
      key: 'profile',
      children: (
        <StudentProfileContent
          platformSettings={platformSettings}
          customProfileFields={customProfileFields}
          student={student}
          setUser={setUser}
          setModal={setModal}
          getUser={getUser}
          onClickByParent={onClickByParent}
          onSave={onSave}
        />
      ),
    },
    {
      label: 'Курсы',
      key: 'directions',
      children: (
        <StudentDirectionsContent
          platformSettings={platformSettings}
          customProfileFields={customProfileFields}
          student={student}
          setModal={setModal}
          getDirection={getDirection}
          canViewFinancialData={canViewFinancialData}
          onClickByTeacher={onClickByTeacher}
          ktpGroupSelections={ktpGroupSelections}
          onKtpGroupSelectionChange={onKtpGroupSelectionChange}
          showKtpGroupSelectionErrors={showKtpGroupSelectionErrors}
        />
      ),
    },
    ...(platformSettings?.isPurposePaymentsEnabled === '1'
      ? [
          {
            label: 'Оплаты по назначению',
            key: 'purpose-payments',
            children: <PurposePaymentsTab student={student} />,
          },
        ]
      : []),
    {
      label: 'Отделы и договоры',
      key: 'departments-contracts',
      children: (
        <StudentDepartmentsAndContractsTab
          platformSettings={platformSettings}
          customProfileFields={customProfileFields}
          student={student}
          setModal={setModal}
          getUser={getUser}
          departmentsSection={
            <StudentDepartmentList
              student={student}
              onAddDepartment={() => {
                getUser(false)
              }}
              onRemoveDepartment={() => {
                getUser(false)
              }}
            />
          }
        />
      ),
    },
    ...(canManageBilling && student?.id ? [{
      label: 'Счета и акты',
      key: 'billing',
      children: <StudentBilling userId={student.id} onPaymentChange={() => { getUser(false); getDirection() }} />,
    }] : []),
    {
      label: 'Статусы занятий',
      key: 'lessons-statuses',
      children: (
        <LessonStatusesTab
          student={student}
          refreshKey={lessonStatusesRevision}
          onReportChange={() => Promise.all([getDirection(), getUser(false)])}
        />
      ),
    },
     {
      label: 'Динамика обучения',
      key: 'progress',
      children: <StudentLearningDynamics student={student} />,
    },
    {
      label: 'Мои чаты',
      key: 'chats',
      children: <StudentChatsTab studentId={student?.id} />,
    },
  ]

  const hasLead = Array.isArray(student?.crmLead) && student.crmLead.length > 0

  if (hasLead) {
    tabItems.push({
      label: (
        <OpenLeadProfileTab
          onClick={() => onClickByLead(student.crmLead[0]?.id)}
        />
      ),
      key: 'crm-lead',
    })
  } else {
    tabItems.push({
      label: (
        <CreateLeadProfileTab
          student={student}
          onSuccess={() => getUser(false)}
        />
      ),
      key: 'crm-create-lead',
    })
  }

  return (
    <div className={classes.bodyContainer}>
      <Tabs
        className={classes.tabsContainer}
        defaultActiveKey="profile"
        onChange={(key) => {
          if (key === 'lessons-statuses') {
            setLessonStatusesRevision((revision) => revision + 1)
          }
        }}
        items={tabItems}
      />
    </div>
  )
}

const StudentDepartmentList = ({
  student = {},
  onAddDepartment = () => {},
  onRemoveDepartment = () => {},
}) => {
  const addAlert = useAddAlert()
  const [modal, setModal] = useState(null)

  const errorShow = () => {
    addAlert({
      title: 'Ошибка',
      text: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
      type: 'error',
    })
  }

  const removeFromDepartment = (id) => {
    const departmentName =
      student?.orgUnits?.find((item) => item?.id === modal?.id)?.name ?? '-'

    departments
      .deleteEmployee({
        userId: student?.id,
        unitId: id,
      })
      .then((res) => {
        if (res.data === true) {
          addAlert({
            text: `${student?.name} исключен из отдела ${departmentName}!`,
          })
          onRemoveDepartment()
        } else {
          errorShow()
        }
      })
  }

  const addToDepartment = (department) => {
    departments
      .addAnEmployeeToDepartment({
        userId: [student?.id],
        unitId: department?.id,
      })
      .then((res) => {
        if (res.data) {
          onAddDepartment()
          addAlert({
            text: `${student?.name} добавлен в отдел ${department?.name}!`,
          })
        } else {
          errorShow()
        }
      })
  }

  return (
    <>
      <div className={classes.studentsDepartmentsWrapper}>
        <div className={classes.studentsDepartmentsRow}>
          <div className={classes.studentsDepartmentsHeaderCell}>Отдел</div>
          <div className={classes.studentsDepartmentsHeaderCell}>
            Руководитель
          </div>
          <div
            className={classNames(
              classes.studentsDepartmentsHeaderCell,
              classes.studentsDepartmentsHeaderCellAction,
            )}
          >
            <Button
              newDesign
              className={classNames(
                classes.secondaryButton,
                classes.truncateText,
                classes.textSemiBold,
              )}
              action={() => {
                setModal({ type: 'add-department' })
              }}
            >
              Добавить отдел
            </Button>
          </div>
        </div>
        {!student?.orgUnits && (
          <div className={classes.departmentsRowStub}>Отделов нет</div>
        )}
        {student?.orgUnits?.map((item, index) => {
          return (
            <div key={index} className={classes.studentsDepartmentsRow}>
              <div className={classes.studentsDepartmentsCell}>
                {item?.name ?? '-'}
              </div>
              <div className={classes.studentsDepartmentsCell}>
                {item?.head?.name ?? '-'}
              </div>
              <div
                className={classNames(
                  classes.studentsDepartmentsCell,
                  classes.studentsDepartmentsHeaderCellAction,
                )}
              >
                <Button
                  newDesign
                  className={classNames(
                    classes.ternaryButton,
                    classes.truncateText,
                    classes.textSemiBold,
                  )}
                  action={() => {
                    setModal({ type: 'remove-department', id: item?.id })
                  }}
                >
                  Исключить
                </Button>
              </div>
            </div>
          )
        })}
      </div>
      <Modal
        active={modal !== null}
        setActive={() => setModal(null)}
        className={classes.modalWrapper}
      >
        {modal?.type === 'remove-department' && (
          <ActionModal
            title={'Исключить из отдела'}
            content={`Вы уверены что хотите исключить ${
              student?.name
            } из отдела ${
              student?.orgUnits?.find((item) => item?.id === modal?.id).name
            }?`}
            onDismiss={() => setModal(null)}
            onAction={() => {
              removeFromDepartment(modal?.id)
              setModal(null)
            }}
          />
        )}
        {modal?.type === 'add-department' && (
          <SelectDepartmentModal
            title={'Добавить к отделу'}
            onDismiss={() => setModal(null)}
            onSelect={(department) => {
              if (department === null) {
                addAlert({
                  title: 'Нужно выбрать отдел для продолжения!',
                })
                return
              }
              addToDepartment(department)
              setModal(null)
            }}
          />
        )}
      </Modal>
    </>
  )
}

// const DirectionDescription = ({ title, value }) => (
//   <div className={classes.directionDescriptionWrapper}>
//     <div className={classes.directionDescriptionTitle}>{title}</div>
//     <div
//       className={classNames(classes.inputSmallContainer, classes.truncateText)}
//     >
//       {value}
//     </div>
//   </div>
// )

const DirectionDescription = ({ title, value, additionalClass }) => {
  const valueRef = useRef(null)
  const [isOverflowed, setIsOverflowed] = useState(false)

  const handleMouseEnter = () => {
    const el = valueRef.current
    setIsOverflowed(el ? el.scrollWidth > el.clientWidth : false)
  }

  return (
    <div
      className={classNames(
        classes.directionDescriptionWrapper,
        additionalClass,
      )}
    >
      <div className={classes.directionDescriptionTitle}>{title}</div>
      <Tooltip title={isOverflowed ? value : ''} placement="topLeft">
        <span
          ref={valueRef}
          className={classNames(
            classes.inputSmallContainer,
            classes.truncateText,
          )}
          onMouseEnter={handleMouseEnter}
        >
          {value}
        </span>
      </Tooltip>
    </div>
  )
}

const StudentDirectionsContent = ({
  platformSettings = {},
  customProfileFields = [],
  student = {},
  setModal = () => {},
  getDirection = () => {},
  canViewFinancialData = true,
  onClickByTeacher = () => {},
  ktpGroupSelections = [],
  onKtpGroupSelectionChange = () => {},
  showKtpGroupSelectionErrors = false,
}) => {
  const userIdsAllowedToDeleteCourses =
    platformSettings?.userIdsAllowedToDeleteCourses
      ? JSON.parse(platformSettings?.userIdsAllowedToDeleteCourses)
      : []
  const selectEmployeesWhoAreAllowedDeleteCourses =
    platformSettings?.selectEmployeesWhoAreAllowedDeleteCourses === '1'
  const userIdsAllowedToTransferStudents =
    platformSettings?.userIdsAllowedToTransferStudents
      ? JSON.parse(platformSettings?.userIdsAllowedToTransferStudents)
      : []
  const selectEmployeesWhoAreAllowedTransferStudents =
    platformSettings?.selectEmployeesWhoAreAllowedTransferStudents === '1'

  const profile = useSelector(selectProfile)

  const addAlert = useAddAlert()
  const [directionOrders, setDirectionOrders] = useState([])
  const [privateInfo, setPrivateInfo] = useState([])
  const [userClasses, setUserClasses] = useState([])
  const [modalRemoveClass, setModalRemoveClass] = useState({
    active: false,
    data: {},
  })
  const [modalDetachGroup, setModalDetachGroup] = useState({
    isOpen: false,
  })
  const [additionalTeachersOrder, setAdditionalTeachersOrder] = useState(null)

  const fetchClasses = () => {
    classApi.showByUser(student.id).then(({ data }) => {
      setUserClasses(data?.data ?? [])
    })
  }

  useEffect(() => {
    fetchClasses()
  }, [student.id])

  useEffect(() => {
    const newPrivateInfo = []
    student.childrenDirection?.forEach(
      (order) => order?.privateInfo?.id && newPrivateInfo.push(order),
    )
    setPrivateInfo(newPrivateInfo)
  }, [student.childrenDirection])

  useEffect(() => {
    setDirectionOrders(
      sortDirectionOrdersByDirectionSorting(
        student?.childrenDirection?.filter(({ class_id }) => !class_id) ?? [],
      ),
    )
  }, [student.childrenDirection])

  // Тариф заказа берём из ответа API (expand=tariff): он не зависит от
  // франшизной фильтрации directionTariffs. Поиск по тарифам курса — запасной путь.
  const getTariff = (item) =>
    item?.tariff ??
    item?.direction?.directionTariffs?.find(
      (tariff) => tariff.id === item.tariff_id,
    )

  const formatBalanceValue = (value) =>
    Number(value).toFixed(2).replace(/\.?0+$/, '')

  const getPrivateBalanceLabel = (direction) => {
    const privateBalance = Number(direction?.private_balance)
    const lessonPrice = Number(
      direction?.privateInfo?.hour_cost ?? getTariff(direction)?.first_price,
    )

    if (
      Number.isFinite(privateBalance) &&
      Number.isFinite(lessonPrice) &&
      lessonPrice > 0
    ) {
      const lessonsLeft = privateBalance / lessonPrice

      return `${formatBalanceValue(privateBalance)} руб. = ${formatBalanceValue(lessonsLeft)} занятия`
    }

    const tariffType = getTariff(direction)?.type
    return `${
      tariffType === 'minute'
        ? Math.floor(direction?.buy_hours ?? 0)
        : Number(direction?.buy_hours ?? 0).toFixed(2)
    } ${tariffType === 'minute' ? 'минут' : 'часов'}`
  }

  const formatCoursePrice = (value) =>
    value || value === 0 ? `${formatBalanceValue(value)} руб.` : '-'

  const getPeriodPriceRows = (tariff) => {
    if (!tariff) return []

    if (tariff.type === 'stream_custom_period') {
      return (tariff.tariffPeriods ?? []).map((item) => ({
        period: `${item.months} ${declOfNum(item.months, [
          'месяц',
          'месяца',
          'месяцев',
        ])}`,
        price: item.price,
      }))
    }

    if (tariff.type === 'stream_custom_days') {
      return (tariff.tariffDays ?? []).map((item) => ({
        period: `${item.days} ${declOfNum(item.days, [
          'день',
          'дня',
          'дней',
        ])}`,
        price: item.price,
      }))
    }

    if (tariff.type === 'stream_custom_weeks') {
      return (tariff.tariffWeeks ?? []).map((item) => ({
        period: `${item.weeks} ${declOfNum(item.weeks, [
          'неделя',
          'недели',
          'недель',
        ])}`,
        price: item.price,
      }))
    }

    return []
  }

  const renderPeriodPriceTooltip = (tariff) => {
    const rows = getPeriodPriceRows(tariff)

    return (
      <div className={classes.studentDirectionsPeriodTooltip}>
        {rows.length > 0 ? (
          rows.map((row) => (
            <div
              key={`${row.period}-${row.price}`}
              className={classes.studentDirectionsPeriodTooltipRow}
            >
              <span>{row.period}</span>
              <b>{formatCoursePrice(row.price)}</b>
            </div>
          ))
        ) : (
          <div className={classes.studentDirectionsMuted}>Нет периодов</div>
        )}
      </div>
    )
  }

  const handleAttachClass = () => {
    setModal({
      type: 'AddClass',
      data: {
        selected: student.childrenDirection
          ?.filter(({ class_id }) => userClasses.find((c) => c.id === class_id))
          ?.map(({ class_id }) => class_id),
        onSuccess: () => {
          getDirection()
          fetchClasses()
        },
        onError: (res) => {
          addAlert({
            type: 'error',
            title: 'Не удалось добавить класс',
            text: res?.data?.error ?? undefined,
          })
        },
      },
    })
  }

  const handleDetachGroup = (group, elClass) => {
    setModalDetachGroup({
      isOpen: true,
      text: `Вы действительно хотите удалить ученика из группы "${group.name}"?`,
      onConfirm: () => {
        classApi
          .detachUserClassGroup(elClass.id, {
            direction_group_id: group.id,
            user_id: student.id,
          })
          .then(() => {
            getDirection()
            fetchClasses()
          })
        setModalDetachGroup((prev) => {
          return { isOpen: false }
        })
      },
      onDismiss: () => {
        setModalDetachGroup((prev) => {
          return { isOpen: false }
        })
      },
    })
  }

  const handleAttachGroup = (elClass) => {
    setModal({
      type: 'AddGroupToClass',
      data: {
        classId: elClass.id,
        selected: student.childrenDirection
          ?.filter(({ class_id }) => class_id === elClass.id)
          ?.map(({ direction_id }) => direction_id),
        filterByDirection: true,
        onSuccess: () => {
          getDirection()
          fetchClasses()
        },
        onError: ({ data }) =>
          addAlert({
            type: 'error',
            title: 'Не удалось добавить группу',
            text: Object.entries(data.data)[0][1] || '',
          }),
      },
    })
  }

  const handleDetachClass = (elClass) => {
    openModalRemoveClass({
      user_id: student.id,
      elClass: elClass,
    })
  }

  const handleTransferClass = (elClass) => {
    setModal({
      type: 'AddClass',
      data: {
        mode: 'transferClass',
        fromClassId: elClass.id,
        selected: userClasses.map(({ id }) => id),
        onSuccess: () => {
          getDirection()
          fetchClasses()
        },
        onError: (res = {}) => {
          const error = res?.data?.error

          addAlert({
            type: 'error',
            title: 'Не удалось перевести класс',
            text:
              (Array.isArray(error) ? error[0] : error) ||
              res?.data?.message ||
              Object.entries(res?.data?.data ?? {})[0]?.[1] ||
              '',
          })
        },
      },
    })
  }

  const closeModalRemoveClass = () => {
    setModalRemoveClass({ active: false, data: {} })
  }
  const openModalRemoveClass = (data) => {
    setModalRemoveClass({ active: true, data })
  }

  const openRenewalModal = (order, classData = null) => {
    if (!order) return
    const modalClassData =
      classData && !Array.isArray(classData?.classUser)
        ? { ...classData, classUser: classData?.classUser ? [classData.classUser] : [] }
        : classData

    setModal({
      type: 'ExtendTraining',
      data: {
        ...order,
        children: order.children ?? student,
        tariff: order.tariff ?? getTariff(order),
        class: modalClassData ?? order.class,
        class_id: modalClassData?.id ?? order.class_id,
      },
      onSuccess: () => {
        getDirection()
        fetchClasses()
      },
    })
  }

  const openEditCourseModal = (direction) => {
    setModal({
      type: 'AddDirection',
      data: {
        orders: directionOrders ?? [],
        directions:
          platformSettings?.allowStudentToEnrollSameCourseInDifferentGroups ===
          '1'
            ? []
            : directionOrders
                ?.map(({ direction_id }) => direction_id)
                .filter((el) => el !== direction.direction_id),
        item: privateInfo?.find((el) => direction.id === el.id),
      },
    })
  }

  const activeProfileFields = getStudentProfileFields(
    platformSettings,
    customProfileFields,
  ).filter((field) => isStudentProfileFieldVisibleForRole(field, profile?.role))
  const visibleProfileFields = getStudentProfileFields(
    platformSettings,
    customProfileFields,
    true,
  ).filter((field) => isStudentProfileFieldVisibleForRole(field, profile?.role))
  const isFieldVisible = (fieldId) =>
    visibleProfileFields.some((field) => field.id === fieldId)
  const isFieldActive = (fieldId) =>
    activeProfileFields.some((field) => field.id === fieldId)
  const paymentWithoutRegistrationLink = getPaymentWithoutRegistrationLink(
    student?.id,
  )
  const showPaymentWithoutRegistrationLinks =
    canViewFinancialData && isFieldVisible('paymentLink')
  const showCourses = isFieldVisible('courses')
  const showClasses = isFieldVisible('classes')
  const canManageCourses = isFieldActive('courses')
  const canManageClasses = isFieldActive('classes')
  const canManageCourseFinancials = canViewFinancialData && canManageCourses
  const canManageClassFinancials = canViewFinancialData && canManageClasses
  const showKtpGroupColumn = ktpGroupSelections.some(
    (selection) => selection.groups.length > 1,
  )
  const renderKtpGroupSelection = (direction) => {
    const tariffType = getTariff(direction)?.type
    const isGroupTariff = [
      'month',
      'free',
      'stream_one_time',
      'stream_custom_period',
      'stream_custom_days',
      'stream_custom_weeks',
      'group_per_lesson',
    ].includes(tariffType)
    const isPrivateLessonPayment =
      ['hour', 'minute'].includes(tariffType) ||
      !!direction?.privateInfo?.salary_per_hour
    const isIndividualTariff =
      !direction.group_id &&
      !isGroupTariff &&
      (isPrivateLessonPayment || direction?.teacher_id)
    const ktpGroupSelection = ktpGroupSelections.find(
      (selection) =>
        Number(selection.direction_id) ===
        Number(direction.direction_id ?? direction.direction?.id),
    )
    const ktpGroups =
      !isIndividualTariff && !isPrivateLessonPayment
        ? ktpGroupSelection?.groups ?? []
        : []
    const rowGroupId = direction.group_id ?? direction.group?.id
    const rowKtpGroups = ktpGroups.filter(
      (group) => Number(group.group_id) === Number(rowGroupId),
    )
    const isOnlyKtpGroup = ktpGroups.length === 1
    const hasKtpGroupSelectionError =
      showKtpGroupSelectionErrors &&
      ktpGroupSelection?.selection_required &&
      !ktpGroupSelection.groups.some(
        (group) => group.group_id === ktpGroupSelection.group_id,
      )

    if (ktpGroups.length <= 1 || rowKtpGroups.length === 0) {
      return <span className={classes.studentDirectionsDash}>-</span>
    }

    return (
      <>
        {rowKtpGroups.map((ktpGroup) => {
          const isKtpGroupSelected =
            isOnlyKtpGroup ||
            Number(ktpGroup.group_id) === Number(ktpGroupSelection.group_id)
          const selectKtpGroup = () => {
            if (isOnlyKtpGroup || isKtpGroupSelected) return

            onKtpGroupSelectionChange(
              ktpGroupSelection.direction_id,
              ktpGroup.group_id,
            )
          }

          return (
            <Tooltip
              key={ktpGroup.group_id}
              title="При смене группы доступ к материалам курса пересчитается по её КТП. Некоторые темы и уроки могут открыться или закрыться. Ранее назначенные задания сохранятся."
            >
              <span className={classes.ktpGroupCheckboxWrapper}>
                <CheckboxViolet
                  value={isKtpGroupSelected}
                  noCheckImg={!isKtpGroupSelected}
                  className={classes.ktpGroupCheckbox}
                  blockClassName={classNames(
                    classes.ktpGroupCheckboxControl,
                    hasKtpGroupSelectionError && classes.ktpGroupSelectionError,
                  )}
                  textClassName={classes.ktpGroupCheckboxText}
                  role="checkbox"
                  aria-label={`КТП курса «${ktpGroupSelection.direction_name}»: ${ktpGroup.group_name}`}
                  aria-checked={isKtpGroupSelected}
                  aria-disabled={isOnlyKtpGroup}
                  aria-invalid={Boolean(hasKtpGroupSelectionError)}
                  tabIndex={0}
                  onClick={selectKtpGroup}
                  onKeyDown={(event) => {
                    if (event.key === ' ' || event.key === 'Enter') {
                      event.preventDefault()
                      selectKtpGroup()
                    }
                  }}
                />
              </span>
            </Tooltip>
          )
        })}
        {hasKtpGroupSelectionError && (
          <div className={classes.ktpGroupSelectionErrorText}>
            Выберите одну группу КТП
          </div>
        )}
      </>
    )
  }
  const courseTableColumns = [
    '120px',
    '160px',
    '120px',
    '160px',
    showKtpGroupColumn ? '72px' : null,
    '190px',
    canManageCourseFinancials ? '150px' : null,
    showPaymentWithoutRegistrationLinks ? '165px' : null,
    '180px',
    canManageCourseFinancials ? '125px' : null,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes.bodyContent}>
      {showPaymentWithoutRegistrationLinks && (
      <div className={classes.paymentWithoutRegistrationLinkWrapper}>
          <div className={classes.paymentWithoutRegistrationLinkTitle}>
            <Tooltip title="Скопировав данную ссылку и отправив ее учащемуся или родителю, при переходе пользователь сможет увидеть все оплаченные им курсы и продлить обучение в любом из них">
              <InfoCircleOutlined
                className={classes.paymentWithoutRegistrationLinkInfo}
              />
            </Tooltip>
            Ссылка на продление обучения
          </div>
          <Text
            type="lightGray"
            // title="Скопировать ссылку на продление обучения"
            texts={[paymentWithoutRegistrationLink]}
            copy={{
              show: true,
              copyText: 'Ссылка на продление обучения скопирована',
            }}
          />
      </div>
      )}
      <div
        className={classes.studentDirectionsSection}
        style={{
          display: showCourses ? undefined : 'none',
        }}
      >
        <div className={classes.studentDirectionsSectionHeader}>
          <div>
            <div className={classes.headerTitleDirection}>Курсы</div>
            <div className={classes.studentDirectionsSectionCaption}>
              Все активные курсы учащегося, оплата и действия в одной таблице
            </div>
          </div>
          {canManageCourseFinancials && (
            <Button
              newDesign
              className={classNames(
                classes.primaryButton,
                classes.truncateText,
                classes.fontWeight500,
              )}
              onClick={() => {
                setModal({
                  type: 'AddDirection',
                  data: {
                    orders: directionOrders ?? [],
                    directions:
                      platformSettings?.allowStudentToEnrollSameCourseInDifferentGroups ===
                      '1'
                        ? []
                        : directionOrders?.map(
                            ({ direction_id }) => direction_id,
                          ),
                  },
                })
              }}
            >
              Добавить курс
            </Button>
          )}
        </div>
        {directionOrders?.length > 0 ? (
          <div className={classes.studentDirectionsTableViewport}>
            <div className={classes.studentDirectionsTable}>
              <div
                className={classNames(
                  classes.studentDirectionsTableRow,
                  classes.studentDirectionsTableHead,
                )}
                style={{ gridTemplateColumns: courseTableColumns }}
              >
                <StudentDirectionsHeaderCell tooltip="Действия с курсом">
                  <InfoCircleOutlined className={classes.studentDirectionsHeaderIcon} />
                </StudentDirectionsHeaderCell>
                <StudentDirectionsHeaderCell tooltip="Название курса и дата, когда курс был добавлен учащемуся">
                  Курс / дата
                </StudentDirectionsHeaderCell>
                <StudentDirectionsHeaderCell tooltip="Тариф, по которому учащийся проходит курс">
                  Тариф
                </StudentDirectionsHeaderCell>
                <StudentDirectionsHeaderCell tooltip="Группа курса и закрепленный педагог. Если группа не назначена, показывается индивидуальный педагог или статус распределения">
                  Группа / педагог
                </StudentDirectionsHeaderCell>
                {showKtpGroupColumn && (
                  <StudentDirectionsHeaderCell tooltip="Группа, по КТП которой открываются материалы курса. Для каждого курса выбирается одна группа.">
                    <span className={classes.studentDirectionsInlineInfo}>
                      КТП
                      <InfoCircleOutlined className={classes.ktpGroupHeaderIcon} />
                    </span>
                  </StudentDirectionsHeaderCell>
                )}
                <StudentDirectionsHeaderCell tooltip="Текущий статус оплаты, дата следующего платежа и скидка, если она доступна для редактирования">
                  Оплата
                </StudentDirectionsHeaderCell>
                {canManageCourseFinancials && (
                  <StudentDirectionsHeaderCell tooltip="Скидка по курсу, если тариф позволяет ее редактировать">
                    Скидка
                  </StudentDirectionsHeaderCell>
                )}
                {showPaymentWithoutRegistrationLinks && (
                  <StudentDirectionsHeaderCell tooltip="Индивидуальная ссылка для продления обучения по этому курсу">
                    Ссылка на продление
                  </StudentDirectionsHeaderCell>
                )}
                <StudentDirectionsHeaderCell tooltip="Для группового курса список изменяется сразу у всей группы, для индивидуального — только у этого ученика">
                  Доп. педагоги
                </StudentDirectionsHeaderCell>
                {canManageCourseFinancials && (
                  <StudentDirectionsHeaderCell tooltip="Платежный идентификатор курса для сверки оплат">
                    Pay ID
                  </StudentDirectionsHeaderCell>
                )}
              </div>
              {directionOrders?.map((direction, index) => {
                const tariff = getTariff(direction)
                const demoPeriod = getCourseDemoPeriodInfo(direction)
                const tariffType = tariff?.type
                const isGroupTariff = [
                  'month',
                  'free',
                  'stream_one_time',
                  'stream_custom_period',
                  'stream_custom_days',
                  'stream_custom_weeks',
                  'group_per_lesson',
                ].includes(tariffType)
                const isSharedGroupBalance =
                  tariffType === 'group_per_lesson' &&
                  !!direction?.group?.is_shared_balance
                const groupLessonBalance = isSharedGroupBalance
                  ? direction?.group?.shared_balance ??
                    direction?.payment_amount
                  : direction?.payment_amount
                const teacherName = tariff?.any_seminarian
                  ? 'Любой учитель'
                  : direction.group_id
                  ? direction?.group?.teacher?.name ?? 'Не распределено'
                  : direction?.teacher?.name ?? 'Не распределено'
                const groupName = direction?.group?.name ?? 'Без группы'
                const teacherId = tariff?.any_seminarian
                  ? null
                  : direction.group_id
                  ? direction?.group?.teacher?.id ?? direction?.group?.teacher_id
                  : direction?.teacher?.id ?? direction?.teacher_id
                const duration = direction?.privateInfo?.default_duration
                const durationShortLabel = duration ? `${duration} мин` : '-'
                const paymentDetails = []
                const isPaidUntilVisible =
                  canViewFinancialData &&
                  dayjs(direction?.next_payment_date).isValid() &&
                  !['free', 'stream_one_time', 'hour', 'minute'].includes(
                    tariffType,
                  )
                const canRenewCourse =
                  canManageCourseFinancials &&
                  !['free', 'stream_one_time'].includes(tariffType)
                const canEditCourse =
                  canManageCourseFinancials &&
                  (['group_per_lesson'].includes(tariffType) ||
                    ['hour', 'minute'].includes(tariffType) ||
                    direction?.privateInfo?.salary_per_hour)
                const canDeleteCourse =
                  canManageCourses &&
                  (userIdsAllowedToDeleteCourses.includes(profile.id) ||
                    !selectEmployeesWhoAreAllowedDeleteCourses)
                const hasCourseDiscount =
                  canManageCourseFinancials &&
                  ![
                    'hour',
                    'minute',
                    'free',
                    'stream_one_time',
                    'group_per_lesson',
                  ].includes(tariffType)
                if (canViewFinancialData && tariffType === 'stream_one_time') {
                  paymentDetails.push({
                    title: 'Цена',
                    value: formatCoursePrice(tariff?.first_price),
                  })
                }
                if (canViewFinancialData && tariffType === 'month') {
                  paymentDetails.push({
                    title: 'Цена',
                    value: `${formatCoursePrice(tariff?.first_price)}/мес`,
                  })
                }
                if (
                  canViewFinancialData &&
                  [
                    'stream_custom_period',
                    'stream_custom_days',
                    'stream_custom_weeks',
                  ].includes(tariffType)
                ) {
                  paymentDetails.push({
                    title: 'Цена по периодам',
                    value: renderPeriodPriceTooltip(tariff),
                  })
                }
                const isGroupPerLessonPayment =
                  ['group_per_lesson'].includes(tariffType) &&
                  !!direction?.status_payment
                const isPrivateLessonPayment =
                  ['hour', 'minute'].includes(tariffType) || !!direction?.privateInfo?.salary_per_hour
                const isIndividualTariff =
                  !direction.group_id &&
                  !isGroupTariff &&
                  (isPrivateLessonPayment ||
                    ['hour', 'minute'].includes(tariffType) ||
                    direction?.teacher_id)
                const canEditAdditionalTeachers =
                  !!direction.group_id ||
                  ['hour', 'minute'].includes(tariffType)
                const canChangeGroup =
                  canManageCourseFinancials &&
                  (direction.group_id || isGroupTariff) &&
                  tariffType !== 'group_per_lesson'
                // Показываем купленный тариф: подпись не должна меняться из-за
                // того, что при распределении педагогу заполняется salary_per_hour.
                const tariffName =
                  tariffType === 'group_per_lesson'
                    ? 'Групп. оплата по занятиям'
                    : getTariff(direction)?.name ??
                      (isPrivateLessonPayment ? 'Индив. занятия' : '-')
                if (
                  canViewFinancialData &&
                  (isGroupPerLessonPayment || isPrivateLessonPayment)
                ) {
                  // Цена 0, указанная в карточке ученика, — бесплатные занятия, а не «цена не указана».
                  const isFreeCustomLessonPrice =
                    !isPrivateLessonPayment &&
                    Number(direction?.is_custom_lesson_price) === 1 &&
                    Number(direction?.privateInfo?.hour_cost ?? 0) === 0
                  const lessonPaymentRows = [
                    {
                      title: `Цена/${durationShortLabel}`,
                      value: direction?.privateInfo?.hour_cost
                        ? `${direction.privateInfo.hour_cost} руб.`
                        : isFreeCustomLessonPrice
                        ? '0 руб.'
                        : '-',
                    },
                  ]
                  if (isPrivateLessonPayment) {
                    lessonPaymentRows.push({
                      title: `Пед/${durationShortLabel}`,
                      value: direction?.privateInfo?.salary_per_hour
                        ? `${direction.privateInfo.salary_per_hour} руб.`
                        : '-',
                    })
                  }
                  lessonPaymentRows.push({
                    title: isSharedGroupBalance ? 'Баланс группы' : 'Баланс',
                    value: isPrivateLessonPayment ? (
                      getPrivateBalanceLabel(direction)
                    ) : isFreeCustomLessonPrice ? (
                      `${groupLessonBalance}₽, занятия бесплатные`
                    ) : Number(direction?.privateInfo?.hour_cost ?? 0) <= 0 ? (
                      <Tooltip title="Цена за занятие не указана ни в тарифе, ни для ученика. Рассчитать количество занятий невозможно.">
                        <span>
                          {groupLessonBalance}₽ = расчёт недоступен{' '}
                          <InfoCircleOutlined />
                        </span>
                      </Tooltip>
                    ) : (
                      `${groupLessonBalance}₽ = ${Number(
                        direction?.buy_hours ?? 0,
                      ).toFixed(1)} ${declOfNum(
                        Number(direction?.buy_hours ?? 0).toFixed(1),
                        ['занятие', 'занятия', 'занятий'],
                      )}`
                    ),
                  })
                  paymentDetails.push(...lessonPaymentRows)
                }
                const hasPaymentInfo =
                  (canViewFinancialData && direction?.status_payment !== 1) ||
                  isPaidUntilVisible ||
                  ['free', 'stream_one_time'].includes(tariffType) ||
                  paymentDetails.length > 0
                const hasCourseActions =
                  canRenewCourse || canEditCourse || canDeleteCourse

                return (
                  <div
                    className={classes.studentDirectionsTableItem}
                    key={direction?.id ?? index}
                  >
                    <div
                      className={classes.studentDirectionsTableRow}
                      style={{ gridTemplateColumns: courseTableColumns }}
                    >
                    <StudentDirectionsTableCell
                      label="Действия"
                      className={classes.studentDirectionsActionsCell}
                    >
                      {hasCourseActions ? (
                        <div className={classes.studentDirectionsActions}>
                          {canRenewCourse && (
                            <Tooltip title="Продлить доступ к курсу">
                              <button
                                type="button"
                                onClick={() => openRenewalModal(direction)}
                                className={classNames(
                                  classes.renewButton,
                                  classes.renewIconButton,
                                )}
                              >
                                Продлить
                              </button>
                            </Tooltip>
                          )}
                          {canEditCourse && (
                            <div
                              onClick={() => openEditCourseModal(direction)}
                              className={classes.secondaryIcon}
                            >
                              <IcoEdit />
                            </div>
                          )}
                          {canDeleteCourse && (
                            <div
                              onClick={() => {
                                setModal({
                                  type: 'RemoveDirection',
                                  data: direction.id,
                                })
                              }}
                              className={classes.secondaryIcon}
                            >
                              <IcoRemove />
                            </div>
                          )}
                        </div>
                      ) : (
                        <span className={classes.studentDirectionsDash}>-</span>
                      )}
                    </StudentDirectionsTableCell>
                    <StudentDirectionsTableCell
                      label="Курс / дата"
                      className={classes.studentDirectionsCourseCell}
                    >
                      <div className={classes.studentDirectionsCourseTitleRow}>
                        <Tooltip
                          title={direction?.direction?.name ?? 'Названия нет'}
                          placement="topLeft"
                        >
                          <div className={classes.studentDirectionsCourseTitle}>
                            {direction?.direction?.name ?? 'Названия нет'}
                          </div>
                        </Tooltip>
                        <DemoPeriodBadge
                          order={{
                            ...direction,
                            children_id: direction.children_id ?? student?.id,
                            tariff,
                          }}
                          compact
                        />
                        <NewCourseBadge
                          order={{
                            ...direction,
                            children_id: direction.children_id ?? student?.id,
                            tariff,
                          }}
                          compact
                        />
                      </div>
                      <div className={classes.studentDirectionsMuted}>
                        Добавлен {formatTimestampDate(direction?.created_at)}
                      </div>
                    </StudentDirectionsTableCell>
                    <StudentDirectionsTableCell label="Тариф">
                      <div className={classes.studentDirectionsValue}>
                        {tariffName}
                      </div>
                    </StudentDirectionsTableCell>
                    <StudentDirectionsTableCell label="Группа / педагог">
                      {!isIndividualTariff &&
                        (canChangeGroup ? (
                          <ChangeGroupCell
                            className={classes.studentDirectionsChangeGroupCell}
                            directionId={direction.direction_id}
                            directionOrderId={direction.id}
                            studentId={student?.id}
                            selectedGroup={direction.group}
                            variant="compact"
                            refetchData={() => {
                              getDirection()
                              fetchClasses()
                            }}
                          />
                        ) : (
                          <div className={classes.studentDirectionsGroupLine}>
                            <span className={classes.studentDirectionsValue}>
                              {groupName}
                            </span>
                            {canManageCourseFinancials &&
                              tariffType === 'group_per_lesson' && (
                                <button
                                  type="button"
                                  className={classes.studentDirectionsInlineEdit}
                                  onClick={() => openEditCourseModal(direction)}
                                >
                                  <EditOutlined />
                                </button>
                              )}
                          </div>
                        ))}
                      {teacherId ? (
                        <button
                          type="button"
                          className={classes.studentDirectionsTeacherButton}
                          onClick={() => onClickByTeacher({ id: teacherId })}
                        >
                          {teacherName}
                        </button>
                      ) : (
                        <div className={classes.studentDirectionsMuted}>
                          {teacherName}
                        </div>
                      )}
                      {isIndividualTariff && canManageCourseFinancials && (
                        <button
                          type="button"
                          className={classes.studentDirectionsInlineEdit}
                          onClick={() => openEditCourseModal(direction)}
                          aria-label="Изменить основного педагога"
                        >
                          <EditOutlined />
                        </button>
                      )}
                    </StudentDirectionsTableCell>
                    {showKtpGroupColumn && (
                      <StudentDirectionsTableCell label="КТП">
                        {renderKtpGroupSelection(direction)}
                      </StudentDirectionsTableCell>
                    )}
                    <StudentDirectionsTableCell
                      label="Оплата"
                      className={classes.studentDirectionsPaymentCell}
                    >
                      <div className={classes.studentDirectionsStatusList}>
                        {canViewFinancialData &&
                          direction?.status_payment !== 1 && !demoPeriod.isDemo && (
                            <StudentDirectionsStatus type="alert">
                              Пока не оплачено
                            </StudentDirectionsStatus>
                          )}
                        {(isPaidUntilVisible || (canViewFinancialData && demoPeriod.isDemo)) && (
                          <StudentDirectionsStatus type="success">
                            {demoPeriod.isDemo ? 'Демо-период до' : 'Оплачено до'}{' '}
                            {dayjs(direction?.next_payment_date).format(
                              'DD.MM.YYYY',
                            )}
                          </StudentDirectionsStatus>
                        )}
                        {tariffType === 'free' && (
                          <StudentDirectionsStatus>Бесплатный</StudentDirectionsStatus>
                        )}
                        {tariffType === 'stream_one_time' && !demoPeriod.isDemo && (
                          <StudentDirectionsStatus>
                            Доступ навсегда
                          </StudentDirectionsStatus>
                        )}
                        {!hasPaymentInfo && (
                          <span className={classes.studentDirectionsDash}>
                            -
                          </span>
                        )}
                      </div>
                      {paymentDetails.length > 0 && (
                        <div className={classes.studentDirectionsPaymentDetails}>
                          {paymentDetails.map(({ title, value }) => (
                            <div
                              key={title}
                              className={classes.studentDirectionsPaymentLine}
                            >
                              <Tooltip title={title} placement="topLeft">
                                <span>{title}</span>
                              </Tooltip>
                              {typeof value === 'string' || typeof value === 'number' ? (
                                <Tooltip title={`${title}: ${value}`} placement="topRight">
                                  <b>{value}</b>
                                </Tooltip>
                              ) : (
                                <b>{value}</b>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </StudentDirectionsTableCell>
                    {canManageCourseFinancials && (
                      <StudentDirectionsTableCell
                        label="Скидка"
                        className={classes.studentDirectionsDiscountCell}
                      >
                        {hasCourseDiscount ? (
                          <CourseDiscountField
                            order={direction}
                            user={student}
                            onUpdate={getDirection}
                          />
                        ) : (
                          <Tooltip title="Скидка к данному тарифу применяться не может.">
                            <span className={classes.studentDirectionsUnavailableDiscount}>
                              <span className={classes.studentDirectionsDash}>-</span>
                              <InfoCircleOutlined
                                className={classes.studentDirectionsInfoIcon}
                              />
                            </span>
                          </Tooltip>
                        )}
                      </StudentDirectionsTableCell>
                    )}
                    {showPaymentWithoutRegistrationLinks && (
                      <StudentDirectionsTableCell label="Ссылка на продление">
                        {!['free', 'stream_one_time'].includes(tariffType) ? (
                          <PaymentWithoutRegistrationDescription
                            additionalClass={classes.studentDirectionsCompactLink}
                            showTitle={false}
                            link={getPaymentWithoutRegistrationOrderLink(
                              student?.id,
                              direction?.id,
                            )}
                          />
                        ) : (
                          <div className={classes.studentDirectionsMuted}>
                            Не требуется
                          </div>
                        )}
                      </StudentDirectionsTableCell>
                    )}
                    <StudentDirectionsTableCell label="Доп. педагоги">
                      {(() => {
                        const additionalTeachers = direction.group_id
                          ? direction.group?.additionalTeachers ??
                            direction.group?.additional_teachers
                          : direction.additionalTeachers ??
                            direction.additional_teachers
                        const temporaryTeachers = direction.group_id
                          ? direction.group?.temporaryAdditionalTeachers
                          : direction.temporaryAdditionalTeachers
                        const allNames = getAdditionalTeacherNames(additionalTeachers, temporaryTeachers)

                        return (
                          <div className={classes.studentDirectionsGroupLine}>
                            <span className={classes.studentDirectionsValue}>
                              {allNames.length ? allNames.join(', ') : '-'}
                            </span>
                            {canManageCourseFinancials &&
                              canEditAdditionalTeachers && (
                              <button
                                type="button"
                                className={classes.studentDirectionsInlineEdit}
                                onClick={() =>
                                  setAdditionalTeachersOrder(direction)
                                }
                              >
                                <EditOutlined />
                              </button>
                            )}
                          </div>
                        )
                      })()}
                    </StudentDirectionsTableCell>
                    {canManageCourseFinancials && (
                      <StudentDirectionsTableCell label="Pay ID">
                        <PaymentIdentifierField
                          type="course"
                          value={direction?.payment_identifier}
                          orderId={direction?.id}
                          onUpdate={getDirection}
                        />
                      </StudentDirectionsTableCell>
                    )}
                  </div>
                </div>
              )
              })}
            </div>
          </div>
        ) : (
          <div className={classes.studentDirectionsEmpty}>
            Учащийся пока не добавлен ни на один курс
          </div>
        )}
        <CourseAdditionalTeachersModal
          open={!!additionalTeachersOrder}
          order={additionalTeachersOrder}
          franchiseId={
            additionalTeachersOrder?.group?.franchise_id ??
            student?.franchise_ids?.[0]
          }
          onClose={() => setAdditionalTeachersOrder(null)}
          onSuccess={getDirection}
        />
      </div>
      <div
        className={classNames(
          classes.studentDirectionsSection,
          classes.studentClassesSection,
        )}
        style={{
          display: showClasses ? undefined : 'none',
        }}
      >
        <div className={classes.studentDirectionsSectionHeader}>
          <div>
            <div className={classes.headerTitleDirection}>
              Классы / Обр.траектории
            </div>
            <div className={classes.studentDirectionsSectionCaption}>
              Траектории с привязанными курсами и финансовыми параметрами
            </div>
          </div>
          {canManageClassFinancials && (
            <Button
              newDesign
              className={classNames(
                classes.primaryButton,
                classes.truncateText,
                classes.primaryButtonV1,
                classes.fontWeight500,
              )}
              onClick={() => handleAttachClass()}
            >
              Добавить класс/траекторию
            </Button>
          )}
        </div>
        {userClasses?.map((userClass, index) => {
          const demoPeriod = getCourseDemoPeriodInfo(userClass?.classUser)
          const isShowPayments = userClass?.classUser?.amount !== null
          const classDirections = sortDirectionOrdersByDirectionSorting(
            getUniqueClassDirections(
              student.childrenDirection?.filter(
                (el) => Number(el.class_id) === Number(userClass?.id),
              ),
            ),
          )
          const classOrder = student.childrenDirection?.find(
            (order) => Number(order.class_id) === Number(userClass?.id),
          )
          const canChangeClass =
            canViewFinancialData &&
            canManageClasses &&
            (userIdsAllowedToDeleteCourses.includes(profile.id) ||
              !selectEmployeesWhoAreAllowedDeleteCourses)
          const canTransferClass =
            canViewFinancialData &&
            canManageClasses &&
            (userIdsAllowedToTransferStudents.includes(profile.id) ||
              !selectEmployeesWhoAreAllowedTransferStudents)
          return (
            <div
              className={classNames(
                classes.cardContainer,
                classes.directionCard,
              )}
              key={index}
            >
              <div className={classes.trajectoryItemHeader}>
                <div className={classes.classHeaderMain}>
                  <div className={classes.classHeaderTitleBlock}>
                    <div className={classes.classHeaderTitleRow}>
                      <div
                        className={classNames(
                          classes.headerTitleDirection,
                          classes.classHeaderTitle,
                        )}
                      >
                        {userClass?.title}
                      </div>
                      <DemoPeriodBadge
                        order={{
                          ...userClass?.classUser,
                          children_id: student?.id,
                          class_id: userClass?.id,
                          class: userClass,
                        }}
                        compact
                      />
                      <NewCourseBadge
                        order={{
                          ...userClass?.classUser,
                          children_id: student?.id,
                          class_id: userClass?.id,
                          class: userClass,
                        }}
                        compact
                      />
                    </div>
                    <div className={classes.classHeaderMeta}>
                      <span>
                        Создан: {formatTimestampDate(userClass?.created_at)}
                      </span>
                      {canViewFinancialData && isShowPayments && (
                        <span>
                          {demoPeriod.isDemo ? 'Демо-период до: ' : userClass?.classUser?.status_payment === 1 ? (
                            'Оплачено до: '
                          ) : (
                            <>
                              <span className={classes.classHeaderPaymentAlert}>
                                Пока не оплачено.
                              </span>{' '}
                              До:{' '}
                            </>
                          )}
                          <Moment
                            date={userClass.classUser.next_payment_date}
                            format="DD MM YYYY"
                            withTitle
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  {showPaymentWithoutRegistrationLinks && userClass?.one_pay && (
                    <div className={classes.classHeaderLink}>
                      <PaymentWithoutRegistrationDescription
                        title="Ссылка на продление"
                        link={getPaymentWithoutRegistrationClassLink(
                          student?.id,
                          userClass?.id,
                        )}
                        additionalClass={classes.paymentWithoutRegistrationHeaderField}
                      />
                    </div>
                  )}
                  {canViewFinancialData &&
                    isShowPayments &&
                    canManageClasses && (
                      <div className={classes.classHeaderPayId}>
                        <PaymentIdentifierField
                          type="class"
                          value={userClass?.classUser?.payment_identifier}
                          classId={userClass?.id}
                          userId={student?.id}
                          onUpdate={fetchClasses}
                        />
                      </div>
                    )}
                </div>
                {canViewFinancialData && isShowPayments && canManageClasses && (
                  <div className={classes.classHeaderFinancials}>
                    <ClassDiscountField
                      user={student}
                      userClass={userClass}
                      onUpdate={fetchClasses}
                    />
                    <ClassPriceField
                      user={student}
                      userClass={userClass}
                      onUpdate={fetchClasses}
                    />
                    {classOrder && (
                      <Tooltip title="Продлить обучение">
                        <button
                          type="button"
                          onClick={() => openRenewalModal(classOrder, userClass)}
                          className={classes.renewButton}
                        >
                          Продлить
                        </button>
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
              <div className={classes.classesListContainer}>
                <div
                  className={classNames(
                    classes.directionCourseItem,
                    showKtpGroupColumn && classes.directionCourseItemWithKtp,
                  )}
                  key={index}
                >
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Курс
                  </div>
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Тариф
                  </div>
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Группа
                  </div>
                  {showKtpGroupColumn && (
                    <Tooltip title="Группа, по КТП которой открываются материалы курса. Для каждого курса выбирается одна группа.">
                      <div
                        className={classNames(
                          classes.directionTableCell,
                          classes.directionCourseItemHeader,
                          classes.directionCourseTableItem,
                          classes.directionCourseKtpCell,
                        )}
                      >
                        <span className={classes.studentDirectionsInlineInfo}>
                          КТП
                          <InfoCircleOutlined className={classes.ktpGroupHeaderIcon} />
                        </span>
                      </div>
                    </Tooltip>
                  )}
                  <div
                    className={classNames(
                      classes.directionTableCell,
                      classes.directionCourseItemHeader,
                      classes.directionCourseTableItem,
                    )}
                  >
                    Преподаватель
                  </div>
                </div>
                {classDirections.map((el) => {
                  return (
                    <CourseInClass
                      key={el.id}
                      name={el.direction?.name}
                      tariffName={
                        el.direction?.directionTariffs?.find(
                          (tariff) => tariff.id === el.tariff_id,
                        )?.name
                      }
                      directionId={el.direction.id}
                      directionOrderId={el.id}
                      group={el?.group}
                      studentId={student?.id}
                      isFree={
                        el.direction?.directionTariffs?.find(
                          (tariff) => tariff.id === el.tariff_id,
                        )?.type === 'free'
                      }
                      getDirection={getDirection}
                      fetchClasses={fetchClasses}
                      seminarianName={el?.group?.teacher_name}
                      userIdsAllowedToDeleteCourses={
                        userIdsAllowedToDeleteCourses
                      }
                      selectEmployeesWhoAreAllowedDeleteCourses={
                        selectEmployeesWhoAreAllowedDeleteCourses
                      }
                      profile={profile}
                      handleDetachGroup={handleDetachGroup}
                      userClass={userClass}
                      index={index}
                      showPaymentWithoutRegistrationLinks={
                        showPaymentWithoutRegistrationLinks
                      }
                      canManageStudentCourses={
                        canViewFinancialData && canManageClasses
                      }
                      ktpGroupContent={
                        showKtpGroupColumn ? renderKtpGroupSelection(el) : null
                      }
                    />
                  )
                })}
                {/* {userClass?.groups
                  ?.filter((group) =>
                    student.childrenDirection?.find(
                      (order) => order.group_id === group.id,
                    ),
                  )
                  ?.map((group, index) => {
                    return (
                      <CourseInClass
                        name = {group.direction?.name}
                        tariffName = {
                          group.direction?.tariffs?.find(
                            (tariff) => tariff.id === group.tariff_id,
                            )?.name
                        }
                        directionId={group.direction.id}
                        directionOrderId={group.direction_order_id}
                        group = {group}
                        getDirection={getDirection}
                        fetchClasses={fetchClasses}
                        seminarianName={group?.seminarian?.name}
                        userIdsAllowedToDeleteCourses={userIdsAllowedToDeleteCourses}
                        selectEmployeesWhoAreAllowedDeleteCourses={selectEmployeesWhoAreAllowedDeleteCourses}
                        profile={profile}
                        handleDetachGroup={handleDetachGroup}
                        userClass={userClass}
                        index={index}
                      />
                    )
                  })} */}
              </div>
              <div className={classes.classActionContainer}>
                {canViewFinancialData && canManageClasses && (
                  <Button
                    newDesign
                    className={classNames(
                      classes.primaryButton,
                      classes.truncateText,
                      classes.fontWeight500,
                    )}
                    onClick={() => handleAttachGroup(userClass)}
                  >
                    Добавить группу
                  </Button>
                )}
                {canChangeClass && (
                  <Button
                    newDesign
                    className={classNames(
                      classes.primaryButton,
                      classes.truncateText,
                      classes.fontWeight500,
                      classes.errorButton,
                    )}
                    onClick={() => handleDetachClass(userClass)}
                  >
                    Удалить класс
                  </Button>
                )}
                {canTransferClass && Number(userClass?.one_pay) === 1 && (
                  <Button
                    newDesign
                    className={classNames(
                      classes.primaryButton,
                      classes.truncateText,
                      classes.fontWeight500,
                    )}
                    onClick={() => handleTransferClass(userClass)}
                  >
                    Перевести в др. класс
                  </Button>
                )}
              </div>
            </div>
          )
        })}
      </div>
      <Modal active={modalRemoveClass.active} setActive={closeModalRemoveClass}>
        <ModalContainer closeModal={closeModalRemoveClass}>
          <ModalRemoveClass
            closeModal={closeModalRemoveClass}
            elClass={modalRemoveClass.data.elClass}
            user_id={modalRemoveClass.data.user_id}
            setClasses={setUserClasses}
            fetchClasses={fetchClasses}
          />
        </ModalContainer>
      </Modal>
      <Modal
        active={modalDetachGroup?.isOpen}
        setActive={() => setModalDetachGroup({ isOpen: false })}
        className={classes.modalWrapper}
      >
        <ActionModal
          title={'Вы точно хотите открепить курс'}
          content={modalDetachGroup?.text}
          onDismiss={modalDetachGroup?.onDismiss}
          onAction={modalDetachGroup?.onConfirm}
        />
      </Modal>
    </div>
  )
}

const ChangeGroupCell = ({
  selectedGroup,
  directionId,
  directionOrderId,
  studentId,
  refetchData,
  className,
  variant = 'select',
}) => {
  const addAlert = useAddAlert()
  const [isOpen, setIsOpen] = useState(false)
  const [selectedGroupId, setSelectedGroupId] = useState(selectedGroup?.id)
  const [isChangingGroup, setIsChangingGroup] = useState(false)

  useEffect(() => {
    setSelectedGroupId(selectedGroup?.id)
  }, [selectedGroup?.id])

  const [groupsState, doFetchGroups] = useAsyncFn(
    async () =>
      await directionGroupApi.get({
        filter: ['[direction_id]=' + directionId],
        student_id: studentId,
      }),
    [],
  )
  const allGroupsData = groupsState.value?.data ?? []
  const options = allGroupsData
    ?.map((g) => ({
      label: g.name,
      value: g.id,
    }))
    ?.filter((item) => item.value !== selectedGroup?.id)
    ?.sort((a, b) => (a.label > b.label ? 1 : -1))

  if (!!selectedGroup?.id) {
    options.unshift({
      label: selectedGroup.name,
      value: selectedGroup.id,
    })
    options.unshift({
      label: 'Оставить без группы',
      value: 0,
    })
  }

  const changeGroup = (newGroupId) => {
    const request = newGroupId
      ? directionGroupApi.moveStudentsToGroup({
          direction_orders_ids: [directionOrderId],
          new_group_id: newGroupId,
        })
      : directionGroupApi.removeStudentsFromGroup({
          direction_orders_ids: [directionOrderId],
          group_id: selectedGroup?.id,
        })

    return request
      .then((res) => {
        if (isError(res)) throw new Error()

        addAlert({
          title: 'Успех',
          text: newGroupId
            ? 'Студент успешно переведён'
            : 'Студент оставлен без группы',
          type: 'success',
        })

        refetchData && refetchData()
      })
      .catch(() => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка перевода студента',
          type: 'error',
        })
      })
  }

  const handlerChangeGroup = (newGroupId) => {
    ModalAnt.confirm({
      title: 'Вы уверены что хотите перевести ученика?',
      content: newGroupId
        ? `В группу "${
            allGroupsData.find((g) => g.id === newGroupId)?.name ??
            '(без названия)'
          }"`
        : 'Курс останется у ученика, но привязка к группе будет снята.',
      icon: null,
      centered: true,
      maskClosable: true,
      className: jclasses.modal,
      okText: 'Подтвердить',
      cancelText: 'Отменить',
      onOk: () => changeGroup(newGroupId),
    })
  }

  const openGroupSelect = () => {
    doFetchGroups()
    setIsOpen(true)
  }

  if (variant === 'compact') {
    return (
      <>
        <div className={classNames(classes.studentDirectionsGroupLine, className)}>
          <span className={classes.studentDirectionsValue}>
            {selectedGroup?.name ?? 'Без группы'}
          </span>
          <button
            type="button"
            className={classes.studentDirectionsInlineEdit}
            onClick={openGroupSelect}
          >
            <EditOutlined />
          </button>
        </div>
        <Modal
          active={isOpen}
          setActive={() => setIsOpen(false)}
          className={classNames(
            classes.modalWrapperOld,
            classes.addDirectionModal,
          )}
          classNameBackground={classes.modalBackground}
        >
          <div className={bodyModalClasses.transferTitleBlock}>
            <h2 className="modal__title">
              {'\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0433\u0440\u0443\u043f\u043f\u0443'}
            </h2>
            <div className={bodyModalClasses.transferTitleInfo}>
              <InfoCircleOutlined className={bodyModalClasses.transferInfoIcon} />
              <span>
                {'\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043d\u043e\u0432\u0443\u044e \u0433\u0440\u0443\u043f\u043f\u0443 \u0434\u043b\u044f \u044d\u0442\u043e\u0433\u043e \u043a\u0443\u0440\u0441\u0430.'}
              </span>
            </div>
          </div>

          <div className={bodyModalClasses.body}>
            <div className={bodyModalClasses.selectWithLabel}>
              <div className={bodyModalClasses.selectLabel}>
                {'\u0413\u0440\u0443\u043f\u043f\u0430'}
              </div>
              <SelectAnt
                showSearch
                className={classNames(
                  bodyModalClasses.select,
                  bodyModalClasses.removeBoxShadow,
                  bodyModalClasses.customSelect,
                )}
                placeholder={
                  '\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u0440\u0443\u043f\u043f\u0443'
                }
                optionFilterProp="label"
                options={options}
                value={selectedGroupId}
                onChange={setSelectedGroupId}
                loading={groupsState.loading}
              />
            </div>
          </div>

          <div className={bodyModalClasses.footerBtn}>
            <Button
              name={'\u041e\u0442\u043c\u0435\u043d\u0430'}
              action={() => setIsOpen(false)}
              newDesign
              className={bodyModalClasses.buttonCancel}
            />
            <Button
              name={'\u041e\u0431\u043d\u043e\u0432\u0438\u0442\u044c'}
              action={() => {
                if (
                  selectedGroupId === null ||
                  selectedGroupId === undefined ||
                  selectedGroupId === selectedGroup?.id
                ) {
                  return
                }

                setIsChangingGroup(true)
                changeGroup(selectedGroupId).finally(() => {
                  setIsChangingGroup(false)
                  setIsOpen(false)
                })
              }}
              disable={
                isChangingGroup ||
                selectedGroupId === null ||
                selectedGroupId === undefined ||
                selectedGroupId === selectedGroup?.id
              }
              loading={isChangingGroup}
              newDesign
              className={bodyModalClasses.buttonPrimary}
            />
          </div>
        </Modal>
      </>
    )
  }

  return (
    <SelectAnt
      className={classNames(iclasses.newSelect, className)}
      popupClassName={iclasses.newSelectPopup}
      placeholder="Выберите группу"
      suffixIcon={
        <EditOutlined
          onMouseDown={(event) => {
            event.preventDefault()
            event.stopPropagation()
            openGroupSelect()
          }}
          onClick={(event) => {
            event.stopPropagation()
            openGroupSelect()
          }}
        />
      }
      options={options}
      value={selectedGroup?.id}
      onChange={handlerChangeGroup}
      open={isOpen}
      onDropdownVisibleChange={(open) => {
        setIsOpen(open)
        if (open) doFetchGroups()
      }}
      onClick={openGroupSelect}
      loading={groupsState.loading}
    />
  )
}

const StudentProfileContent = ({
  platformSettings = {},
  customProfileFields = [],
  student = {},
  setUser = () => {},
  setModal = () => {},
  getUser = () => {},
  onClickByParent = () => {},
  onSave = null,
}) => {
  const addAlert = useAddAlert()
  const profile = useSelector(selectProfile)
  const [referralBalanceModal, setReferralBalanceModal] = useState({
    open: false,
    balance: 0,
    comment: '',
    saving: false,
  })
  const dateFormat = 'YYYY.MM.DD'
  const birthDateFormat = 'DD.MM.YYYY'

  const generalSettings = useSelector(store => store.settings)
  const hideParentsData = Number(generalSettings?.hideParentsData) === 1

  const handleChange = (event, field) => {
    const value = event.target.value
    setUser((prevProfile) => ({
      ...prevProfile,
      [field]: value,
    }))
  }

  const updateNumberSettings = (event, field, min, max, empty = false) => {
    const value = event.target.value
    if (empty && !value) {
      setUser((prevProfile) => ({
        ...prevProfile,
        [field]: '',
      }))
      return
    }
    const percent = Number(value)
    if (Number.isInteger(percent) && percent <= max && percent >= min) {
      setUser((prevProfile) => ({
        ...prevProfile,
        [field]: value,
      }))
    }
  }

  const updateUser = (value, field) => {
    setUser((prevProfile) => ({
      ...prevProfile,
      [field]: value,
    }))
  }

  const isTeacherProfile = isStudentProfileTeacherRole(profile?.role)
  const profileFields = getStudentProfileFields(
    platformSettings,
    customProfileFields,
  ).filter(
    (field) =>
      isStudentProfileFieldVisibleForRole(field, profile?.role) &&
      !(isTeacherProfile && field.id === 'paymentLink'),
  )
  const fieldIdsRenderedOutsideInfoBlock = [
    'name',
    'parents',
    'classes',
    'courses',
    'agreements',
  ]
  const orderedProfileFields = profileFields.filter(
    (field) => !fieldIdsRenderedOutsideInfoBlock.includes(field.id),
  )
  const regularProfileFields = orderedProfileFields.filter(
    (field) => !isTextareaStudentField(field),
  )
  const textAreaProfileFields = orderedProfileFields.filter((field) =>
    isTextareaStudentField(field),
  )
  const customFieldValues = getStudentCustomFieldValues(student)
  const parentFieldVisible = profileFields.some(
    (field) => field.id === 'parents',
  )
  const isParentSettingEnabled = (settingName) => {
    const field = STUDENT_PARENT_FIELDS.find(
      (item) => item.activeSetting === settingName,
    )

    return toBoolean(
      platformSettings?.[settingName] ??
        (getStudentFieldDefaultActive(field) ? '1' : '0'),
    )
  }

  const updateCustomField = (field, value) => {
    setUser((prevProfile) => ({
      ...prevProfile,
      custom_fields: setProfileFieldValue(
        getStudentCustomFieldValues(prevProfile),
        field,
        value,
      ),
    }))
  }

  const isProfileFieldReadonly = () => false
  const getProfileFieldClassName = (field, ...extraClasses) =>
    classNames(
      classes.inputSmallContainer,
      isProfileFieldReadonly(field) && classes.profileReadonlyField,
      ...extraClasses,
    )

  const renderCustomField = (field) => {
    const value = getProfileFieldValue(customFieldValues, field) ?? ''
    const className = getProfileFieldClassName(field)
    const disabled = isProfileFieldReadonly(field)

    if (field.type === STUDENT_FIELD_TYPES.SELECT) {
      return (
        <Tooltip key={field.name} title={field.label}>
          <SelectAnt
            className={className}
            popupClassName={iclasses.newSelectPopup}
            placeholder={field.label}
            value={value || undefined}
            options={(field.value_options ?? []).map((option) => ({
              label: option,
              value: option,
            }))}
            allowClear
            disabled={disabled}
            onChange={(nextValue) => updateCustomField(field, nextValue)}
            onClear={() => updateCustomField(field, '')}
          />
        </Tooltip>
      )
    }

    if (field.type === STUDENT_FIELD_TYPES.DATE) {
      return (
        <Tooltip key={field.name} title={field.label}>
          <DatePicker
            onChange={(date, dateString) => {
              updateCustomField(field, dateString)
            }}
            value={value ? dayjs(String(value).replace(/-/gi, '.'), dateFormat) : null}
            format={dateFormat}
            className={className}
            disabled={disabled}
          />
        </Tooltip>
      )
    }

    return (
      <Tooltip key={field.name} title={field.label}>
        <input
          className={className}
          type={field.type === STUDENT_FIELD_TYPES.NUMBER ? 'number' : 'text'}
          value={value}
          disabled={disabled}
          onChange={(event) => updateCustomField(field, event.target.value)}
          placeholder={field.label}
          title={field.label}
        />
      </Tooltip>
    )
  }

  const renderCustomTextarea = (field) => (
    <ContainerWithHeader key={field.name} title={field.label}>
      <Tooltip title={field.label}>
            <textarea
              className={classNames(
                classes.inputTextAreaContainer,
                isProfileFieldReadonly(field) && classes.profileReadonlyField,
              )}
              rows="3"
              value={getProfileFieldValue(customFieldValues, field) ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(event) => updateCustomField(field, event.target.value)}
          placeholder={field.label}
          title={field.label}
        />
      </Tooltip>
    </ContainerWithHeader>
  )
  const renderProfileField = (field) => {
    if (field.isCustom) return renderCustomField(field)

    switch (field.id) {
      case 'phone':
        return (
          <Tooltip key={field.id} title={field.label}>
            <input
              className={getProfileFieldClassName(field)}
              value={student?.phone ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'phone')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'email':
        return (
          <Tooltip key={field.id} title={field.label}>
            <EmailVerifyWrapper
              visible={platformSettings?.requireStudentEmailConfirmation === '1'}
              verified={student?.is_email_confirmed === 1}
              style={{ width: 'auto' }}
            >
              <input
                className={getProfileFieldClassName(field)}
                value={student?.email ?? ''}
                disabled={isProfileFieldReadonly(field)}
                onChange={(e) => handleChange(e, 'email')}
                placeholder={field.label}
                title={field.label}
              />
            </EmailVerifyWrapper>
          </Tooltip>
        )
      case 'login':
        return (
          <Tooltip key={field.id} title={field.label}>
            <input
              className={getProfileFieldClassName(field)}
              value={student?.login ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'login')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'sex':
        return (
          <Tooltip key={field.id} title={field.label}>
            <SelectAnt
              className={getProfileFieldClassName(field)}
              popupClassName={iclasses.newSelectPopup}
              placeholder={field.label}
              value={student?.sex || undefined}
              options={[
                { label: 'Муж', value: 'male' },
                { label: 'Жен', value: 'female' },
              ]}
              allowClear
              disabled={isProfileFieldReadonly(field)}
              onChange={(value) => updateUser(value, 'sex')}
              onClear={() => updateUser('', 'sex')}
            />
          </Tooltip>
        )
      case 'birthDate':
        return (
          <Tooltip key={field.id} title={field.label}>
            <DatePicker
              onChange={(date) => {
                updateUser(date ? date.format('YYYY-MM-DD') : '', 'birth_date')
              }}
              value={birthDate}
              format={birthDateFormat}
              className={getProfileFieldClassName(field)}
              disabled={isProfileFieldReadonly(field)}
            />
          </Tooltip>
        )
      case 'city':
        return (
          <Tooltip key={field.id} title={field.label}>
            <input
              className={getProfileFieldClassName(field)}
              value={student?.city ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'city')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'promo':
        return (
          <Tooltip key={field.id} title={field.label}>
            <input
              className={getProfileFieldClassName(field)}
              value={student?.promo_code ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'promo_code')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'id':
        return (
          <Tooltip key={field.id} title={field.label}>
            <div className={getProfileFieldClassName(field)} title={field.label}>
              {`ID: ${student?.id}`}
            </div>
          </Tooltip>
        )
      case 'pointer':
        return (
          <Tooltip key={field.id} placement="topLeft" title={field.label}>
            <input
              className={getProfileFieldClassName(field)}
              value={student?.custom_id ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'custom_id')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'socialLink':
        return (
          <Tooltip key={field.id} title={field.label}>
            <input
              className={getProfileFieldClassName(field)}
              value={student?.link_to_vk ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'link_to_vk')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'age':
        return (
          <Tooltip key={field.id} title={STUDENT_AGE_INPUT_TOOLTIP}>
            <input
              className={classNames(
                getProfileFieldClassName(field),
                classes.profileReadonlyField,
              )}
              value={getAgeFromBirthDate(student?.birth_date) ?? ''}
              readOnly
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'timezone':
        return (
          <Tooltip key={field.id} title={field.label}>
            <input
              className={getProfileFieldClassName(field)}
              value={student?.timezone ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) =>
                updateNumberSettings(e, 'timezone', -12, 14, true)
              }
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        )
      case 'studentCardLink':
        return (
          <Tooltip key={field.id} title={field.label}>
            <div className={classes.profileFieldWide}>
              <ContainerWithHeader title={field.label}>
                <div className={classes.studentCardLinkContainer}>
                  <input
                    className={classNames(
                      classes.inputSmallContainer,
                      classes.studentCardLinkInput,
                    )}
                    value={studentCardLink}
                    readOnly
                  />
                  <Button
                    newDesign
                    className={classNames(
                      classes.secondaryButton,
                      classes.studentCardLinkButton,
                    )}
                    onClick={handleCopyStudentCardLink}
                  >
                    <CopyOutlined />
                    Скопировать
                  </Button>
                </div>
              </ContainerWithHeader>
            </div>
          </Tooltip>
        )
      case 'paymentLink':
        return (
          <Tooltip key={field.id} title={field.label}>
            <div className={classes.profileFieldWide}>
              <ContainerWithHeader title={field.label}>
                <input
                  className={classNames(
                    classes.inputSmallContainer,
                    classes.studentCardLinkInput,
                  )}
                  value={paymentWithoutRegistrationLink}
                  readOnly
                />
              </ContainerWithHeader>
            </div>
          </Tooltip>
        )
      case 'gamificationExperience':
        return (
          <Tooltip key={field.id} title={GAMIFICATION_EXPERIENCE_TOOLTIP}>
            <div title={field.label}>
              <LVLCell
                className={classNames(classes.lvlCell, classes.inputSmallContainer)}
                user={student}
              />
            </div>
          </Tooltip>
        )
      case 'gamificationBalance':
        return (
          <Tooltip key={field.id} title={GAMIFICATION_BALANCE_TOOLTIP}>
            <div title={field.label}>
              <GamificationBalanceCell
                className={classNames(classes.lvlCell, classes.inputSmallContainer)}
                user={student}
              />
            </div>
          </Tooltip>
        )
      case 'referralBalance':
        return (
          <Tooltip key={field.id} title={field.label}>
            <div
              className={getProfileFieldClassName(
                field,
                classes.referralBalanceField,
              )}
              title={field.label}
            >
              <span className={classes.referralBalanceLabel}>Реф. баланс:</span>
              <span className={classes.referralBalanceValue}>
                {Number(student?.referral_balance || 0)} ₽
              </span>
              {['admin', 'junior-admin'].includes(getBaseRole(profile?.role)) && (
                <button
                  type="button"
                  className={classes.referralBalanceEditButton}
                  aria-label="Изменить реферальный баланс"
                  onClick={() =>
                    setReferralBalanceModal({
                      open: true,
                      balance: Number(student?.referral_balance || 0),
                      comment: '',
                      saving: false,
                    })
                  }
                >
                  <EditOutlined />
                </button>
              )}
            </div>
          </Tooltip>
        )
      default:
        return null
    }
  }
  const renderProfileTextarea = (field) => {
    if (field.isCustom) return renderCustomTextarea(field)

    if (field.id === 'about') {
      return (
        <ContainerWithHeader key={field.id} title={`${field.label} (заполняет уч.):`}>
          <Tooltip title={field.label}>
            <textarea
              className={classNames(
                classes.inputTextAreaContainer,
                isProfileFieldReadonly(field) && classes.profileReadonlyField,
              )}
              rows="3"
              value={student?.about ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'about')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        </ContainerWithHeader>
      )
    }

    if (field.id === 'aboutStudent') {
      return (
        <ContainerWithHeader key={field.id} title={field.label}>
          <Tooltip title={field.label}>
            <textarea
              className={classNames(
                classes.inputTextAreaContainer,
                isProfileFieldReadonly(field) && classes.profileReadonlyField,
              )}
              rows="3"
              value={student?.about_student ?? ''}
              disabled={isProfileFieldReadonly(field)}
              onChange={(e) => handleChange(e, 'about_student')}
              placeholder={field.label}
              title={field.label}
            />
          </Tooltip>
        </ContainerWithHeader>
      )
    }

    return null
  }

  const birthDate = student?.birth_date
    ? dayjs(student.birth_date.replace(/\./gi, '-'))
    : null

  const parents = Array.isArray(student.parents) ? student.parents : []

  const setParents = (parents) => {
    setUser((prevProfile) => ({
      ...prevProfile,
      parents,
    }))
  }

  const deleteParent = (id) => {
    setParents(parents.filter((parent) => parent.id !== id))
  }

  const [parentsModal, setParentsModal] = useState(false)
  const studentCardLink = getStudentCardLink(student?.id)
  const paymentWithoutRegistrationLink = getPaymentWithoutRegistrationLink(
    student?.id,
  )

  const handleCopyStudentCardLink = async () => {
    if (!studentCardLink) return

    try {
      await copyToClipboard(studentCardLink)
      addAlert({ title: 'Ссылка скопирована' })
    } catch {
      addAlert({
        title: 'Ошибка',
        text: 'Не удалось скопировать ссылку',
        type: 'error',
      })
    }
  }

  const saveReferralBalance = async () => {
    if (!referralBalanceModal.comment.trim()) {
      addAlert({ text: 'Комментарий обязателен', type: 'error' })
      return
    }

    setReferralBalanceModal((value) => ({ ...value, saving: true }))
    try {
      const response = await referralProgramApi.adjustBalance({
        user_id: student.id,
        balance: Number(referralBalanceModal.balance || 0),
        comment: referralBalanceModal.comment.trim(),
      })
      const balance = Number(
        response.data?.balance ?? referralBalanceModal.balance,
      )
      setUser((value) => ({ ...value, referral_balance: balance }))
      setReferralBalanceModal({
        open: false,
        balance: 0,
        comment: '',
        saving: false,
      })
      addAlert({ title: 'Реферальный баланс изменён' })
    } catch (error) {
      setReferralBalanceModal((value) => ({ ...value, saving: false }))
    }
  }

  return (
    <div className={classes.bodyContent}>
      <ModalAnt
        title="Изменение реферального баланса"
        open={referralBalanceModal.open}
        onCancel={() =>
          setReferralBalanceModal((value) => ({ ...value, open: false }))
        }
        footer={
          <div className={classes.referralBalanceModalActions}>
            <ButtonNew
              color="gray"
              onClick={() =>
                setReferralBalanceModal((value) => ({ ...value, open: false }))
              }
              disabled={referralBalanceModal.saving}
            >
              Отмена
            </ButtonNew>
            <ButtonNew
              color="primary"
              onClick={saveReferralBalance}
              isLoading={referralBalanceModal.saving}
              disabled={referralBalanceModal.saving}
            >
              Сохранить
            </ButtonNew>
          </div>
        }
      >
        <InputNumber
          min={0}
          style={{ width: '100%', marginBottom: 12 }}
          value={referralBalanceModal.balance}
          onChange={(balance) =>
            setReferralBalanceModal((value) => ({ ...value, balance }))
          }
          placeholder="Баланс"
        />
        <Input.TextArea
          value={referralBalanceModal.comment}
          onChange={(event) =>
            setReferralBalanceModal((value) => ({
              ...value,
              comment: event.target.value,
            }))
          }
          placeholder="Комментарий (обязательно)"
        />
      </ModalAnt>
      <FranchiseSelect
        value={student?.franchise_ids ?? []}
        onChange={(value) => updateUser(value, 'franchise_ids')}
        required
        disabled={getBaseRole(profile?.role) === 'franchise-manager'}
      />
      {(regularProfileFields.length > 0 ||
        toBoolean(platformSettings?.isShowRating ?? true)) && (
        <div className={classes.profileFieldsGrid}>
          {regularProfileFields.map(renderProfileField)}
          {toBoolean(platformSettings?.isShowRating ?? true) &&
            !regularProfileFields.some(
              (field) => field.id === 'gamificationExperience',
            ) && (
              <Tooltip title={GAMIFICATION_EXPERIENCE_TOOLTIP}>
                <div>
                  <LVLCell
                    className={classNames(classes.lvlCell, classes.inputSmallContainer)}
                    user={student}
                  />
                </div>
              </Tooltip>
          )}
          {toBoolean(platformSettings?.isShowRating ?? true) &&
            !regularProfileFields.some(
              (field) => field.id === 'gamificationBalance',
            ) && (
              <Tooltip title={GAMIFICATION_BALANCE_TOOLTIP}>
                <div>
                  <GamificationBalanceCell
                    className={classNames(classes.lvlCell, classes.inputSmallContainer)}
                    user={student}
                  />
                </div>
              </Tooltip>
          )}
        </div>
      )}
      <div style={hideParentsData ? { display: 'none' } : { display: 'auto' }}>
        {parentFieldVisible &&
          (isParentSettingEnabled('isShowParentNameChild') ||
            isParentSettingEnabled('isShowParentEmailChild') ||
            isParentSettingEnabled('isShowParentPhoneChild')) && (
          <ContainerWithHeader title="Родители:">
            {parents.map((user) => (
              <UserBlock
                user={user}
                deleteUser={deleteParent}
                onClickByUser={onClickByParent}
              />
            ))}
            <Button
              newDesign
              className={classNames(
                classes.secondaryButton,
                classes.truncateText,
                classes.textSemiBold,
              )}
              onClick={() => setParentsModal(true)}
              style={{ width: 'fit-content' }}
            >
              Привязать родителя
            </Button>
            <Modal
              active={parentsModal}
              className={classes.modalWrapperOld}
              setActive={() => setParentsModal(false)}
              classNameBackground={classes.modalBackground}
            >
              <ModalContainer closeModal={() => setParentsModal(false)}>
                <UserSearch
                  selectUsers={parents}
                  setSelectUser={setParents}
                  closeModal={() => setParentsModal(false)}
                  onSave={onSave}
                  roleSeach="parent"
                />
              </ModalContainer>
            </Modal>
            {/* <div className={classes.containerAboutStudentParentsInfo}>
              {toBoolean(platformSettings?.isShowParentNameChild ?? true) && (
                <input
                  className={classes.inputSmallContainer}
                  value={student?.parent_name ?? ''}
                  onChange={(e) => handleChange(e, 'parent_name')}
                  placeholder="Ф.И.О. родителя"
                />
              )}
              {toBoolean(platformSettings?.isShowParentEmailChild ?? true) && (
                <input
                  className={classes.inputSmallContainer}
                  value={student?.parent_email ?? ''}
                  onChange={(e) => handleChange(e, 'parent_email')}
                  placeholder="Почта"
                />
              )}
              {toBoolean(platformSettings?.isShowParentPhoneChild ?? true) && (
                <input
                  className={classes.inputSmallContainer}
                  value={student?.parent_phone ?? ''}
                  onChange={(e) => handleChange(e, 'parent_phone')}
                  placeholder="телефон"
                />
              )}
              <input
                className={classes.inputSmallContainer}
                value={student?.parent_telegram ?? ''}
                onChange={(e) => handleChange(e, 'parent_telegram')}
                placeholder="Ссылка на соц.сеть"
              />
            </div> */}
          </ContainerWithHeader>
        )}
      </div>
      {textAreaProfileFields.length > 0 && (
        <div className={classes.containerAboutStudentInfo}>
          {textAreaProfileFields.map(renderProfileTextarea)}
        </div>
      )}
      {toBoolean(platformSettings?.isEnabledGoalsAndNotes ?? true) && (
        <div className={classes.containerNotesAndGoals}>
          <ContainerWithHeader title="Мои цели">
            <GoalsList userId={student?.id} />
          </ContainerWithHeader>
          <ContainerWithHeader title="Мои заметки">
            <NotesList userId={student?.id} />
          </ContainerWithHeader>
        </div>
      )}
      <HorizontalProfileQRCard user={student} style={{ maxWidth: '450px' }} />
    </div>
  )
}

const ContainerWithHeader = ({ title, children }) => {
  return (
    <div className={classes.containerWithHeader}>
      <div className={classes.containerWithHeaderTitle}>{title}</div>
      {children}
    </div>
  )
}

const StudentAdditionalBalances = ({ platformSettings = {}, studentId }) => {
  const isEnabled = platformSettings?.isStudentBalancesEnabled === '1'
  const balances = normalizeStudentBalances(platformSettings?.studentBalanceSettings)
  const [values, setValues] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!isEnabled || !studentId || balances.length === 0) {
      setValues({})
      return undefined
    }

    let isMounted = true
    setLoading(true)

    Promise.all(
      balances.map((balance) =>
        usersAPI
          .getBalanceOfAdditionalActivities({
            user_id: studentId,
            balance_id: balance.id,
          })
          .then(({ data }) => [balance.id, data?.status === 'success' ? data?.data : 0])
          .catch(() => [balance.id, 0]),
      ),
    ).then((result) => {
      if (!isMounted) return

      setValues(Object.fromEntries(result))
      setLoading(false)
    })

    return () => {
      isMounted = false
    }
  }, [isEnabled, studentId, platformSettings?.studentBalanceSettings])

  if (!isEnabled || balances.length === 0) return null

  return (
    <div className={classes.additionalBalances}>
      {balances.map((balance) => {
        const formattedValue = loading ? '...' : formatRub(values[balance.id])

        return (
          <span className={classes.additionalBalanceItem} key={balance.id}>
            <span className={classes.additionalBalanceName}>
              Баланс: {balance.name}
            </span>
            <Tooltip title={loading ? '' : formattedValue}>
              <b>{formattedValue}</b>
            </Tooltip>
          </span>
        )
      })}
    </div>
  )
}

const StudentProfileHeader = ({
  platformSettings = {},
  student = {},
  setUser = () => {},
  setModal = () => {},
  canViewFinancialData = true,
}) => {
  const isUniversalBalance = platformSettings?.isUniversalBalance === '1'
  const [isModalHistory, setIsModalHistory] = useState(false)
  const registrationDate = formatTimestampDate(student?.created_at)

  return (
    <>
      <div className={classes.headerContainer}>
        <div className={classes.userAvatarContainer}>
          <img
            className={classes.userAvatar}
            src={getAvatar(student)}
            alt={student?.name}
          />
          {canViewFinancialData && (
            <div className={classes.userAvatarEditIconWrapper}>
              <EditIcoNewDesign
                className={classes.userAvatarEditIcon}
                onClick={() => setModal({ type: 'Ava' })}
              />
            </div>
          )}
        </div>
        <div className={classes.userHeaderInfoContainer}>
          <div className={classes.userHeaderNameContainer}>
            <div className={classes.userHeaderNameWithIndicators}>
              <span className={classes.truncateText}>{student?.name}</span>
              <StudentCourseIndicators student={student} compact />
            </div>
            {canViewFinancialData && (
              <EditIcoNewDesign
                className={classes.editIcon}
                onClick={() => setModal({ type: 'Name' })}
              />
            )}
          </div>
          <div className={classes.subheaderContainer}>
            <div className={classes.userHeaderLastActiveContainer}>
              <div className={classes.userHeaderLastActiveDot} />
              <span className={classes.truncateText}>
                {formatLastActionTime(student?.last_login)}
              </span>
            </div>
            {canViewFinancialData && isUniversalBalance && (
              <div className={classes.balance}>
                Баланс:
                <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                  {student.balance + '₽'}
                </span>
                |
                <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                  {Number(student.balance_euro).toFixed(2) + '€'}
                </span>
                |
                <span style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                  {Number(student.balance_dollar).toFixed(2) + '$'}
                </span>
              </div>
            )}
            <StudentAdditionalBalances
              platformSettings={platformSettings}
              studentId={student?.id}
            />
          </div>
        </div>
        <div className={classes.userHeaderRightContainer}>
          {canViewFinancialData && (
            <Button
              newDesign
              className={classNames(classes.primaryButton, classes.truncateText)}
              onClick={() => setIsModalHistory(true)}
            >
              История списаний и начислений
            </Button>
          )}
          <NotificationsSettingsButton
            userId={student?.id}
          />
          <Tooltip title="Дата регистрации" placement="top">
            <div
              className={classNames(
                classes.inputSmallContainer,
                classes.registrationDateContainer,
              )}
            >
              <span className={classes.truncateText}>{registrationDate}</span>
            </div>
          </Tooltip>
        </div>
      </div>
      {canViewFinancialData && (
        <FinancialTransactionsReportModal
          userId={student.id}
          open={isModalHistory}
          onClose={() => setIsModalHistory(false)}
        />
      )}
    </>
  )
}

const ClassDiscountField = ({ user, userClass, onUpdate }) => {
  const addAlert = useAddAlert()
  const defaultValue = Number(userClass?.classUser?.discount ?? 0)
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const saveDiscount = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить скидку',
      })
    }

    let params = {
      class_id: userClass?.id,
      discount: Number(fieldValue),
      discount_currency: 'rub',
      user_id: user.id,
    }

    classApi
      .changeDiscountForChild(params)
      .then((e) => {
        if (e.data.error) {
          onError()
        } else {
          addAlert({
            title: 'Скидка обновлена',
          })
          onUpdate()
        }
      })
      .catch((e) => {
        onError()
      })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      {'\u0421\u043a\u0438\u0434\u043a\u0430'}
      <div className={classes.smallFieldWrapper}>
        <input
          className={classNames(
            classes.inputSmallWithTrailingIcon,
            classes.directionAdditionalDescriptionTitle,
          )}
          value={fieldValue}
          placeholder="0"
          type="number"
          onChange={handleChange}
        />
        <div className={classes.directionAdditionalDescriptionTitle}>
          {'\u0440\u0443\u0431.'}
        </div>
        {Number(fieldValue) !== defaultValue && (
          <button
            type="button"
            className={classes.saveInlineIconButton}
            onClick={saveDiscount}
          >
            <IconDone />
          </button>
        )}
      </div>
    </div>
  )
}

const ClassPriceField = ({ user, userClass, onUpdate }) => {
  const addAlert = useAddAlert()
  const defaultValue = userClass.classUser?.amount
    ? Number(userClass.classUser?.amount ?? 0) +
      Number(userClass.classUser?.discount ?? 0)
    : 0
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const savePrice = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить цену',
      })
    }

    let params = {
      class_id: userClass?.id,
      amount: Number(fieldValue) - Number(userClass.classUser?.discount ?? 0),
      user_id: user.id,
    }
    classApi
      .changePriceForChild(params)
      .then((e) => {
        if (e.data.error) {
          onError()
        } else {
          addAlert({
            title: 'Цена обновлена',
          })
          onUpdate()
        }
      })
      .catch((e) => {
        onError()
      })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      Цена
      <div className={classes.smallFieldWrapper}>
        <input
          className={classNames(
            classes.inputSmallWithTrailingIcon,
            classes.directionAdditionalDescriptionTitle,
          )}
          value={fieldValue}
          placeholder="0"
          type="number"
          onChange={handleChange}
        />
        <div className={classes.directionAdditionalDescriptionTitle}>руб.</div>
      </div>
      {Number(fieldValue) !== defaultValue && (
        <div className={classes.saveIconButton} onClick={savePrice}>
          <IconDone />
        </div>
      )}
    </div>
  )
}

const CourseDiscountField = ({ user, order, onUpdate = () => {} }) => {
  const addAlert = useAddAlert()
  const defaultValue = Number(order?.discount ?? 0)
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const saveDiscount = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить скидку',
      })
    }

    let params = {
      order_id: order?.id,
      discount: Number(fieldValue),
      // discount_currency: 'rub',
      user_id: user.id,
    }

    directionOrdersApi.changeDiscountForChild(params).then(({ data }) => {
      if (data?.status === 'success') {
        addAlert({
          title: 'Скидка обновлена',
        })
        onUpdate()
      } else {
        onError()
      }
    })
  }

  const hasUnsavedValue = Number(fieldValue) !== defaultValue

  return (
    <div
      className={classNames(
        classes.headerDirectionChipWrapper,
        classes.studentDirectionsDiscountField,
      )}
    >
      <div className={classes.wrapper}>
        <div className={classes.directionDescriptionTitle}>
          {'\u0421\u043a\u0438\u0434\u043a\u0430'}
        </div>
        <div className={classes.smallFieldWrapper}>
          <input
            className={classNames(
              classes.inputSmallWithTrailingIcon,
              classes.directionAdditionalDescriptionTitle,
            )}
            value={fieldValue}
            placeholder="0"
            type="number"
            onChange={handleChange}
          />
          {!hasUnsavedValue && (
            <div className={classes.directionAdditionalDescriptionTitle}>
              {'\u0440\u0443\u0431.'}
            </div>
          )}
          {hasUnsavedValue && (
            <button
              type="button"
              className={classes.saveInlineIconButton}
              onClick={saveDiscount}
            >
              <IconDone />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

const CoursePriceField = ({ user, order, onUpdate = () => {} }) => {
  const addAlert = useAddAlert()
  const defaultValue = order?.payment_amount
    ? Number(order?.payment_amount ?? 0) + Number(order?.discount ?? 0)
    : 0
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const handleChange = (e) => {
    setFieldValue(e.target.value)
  }

  const savePrice = () => {
    const onError = () => {
      addAlert({
        type: 'error',
        title: 'Не удалось обновить цену',
      })
    }

    let params = {
      order_id: order?.id,
      payment_amount: Number(fieldValue) - Number(order?.discount ?? 0),
      user_id: user.id,
    }
    directionOrdersApi.changePriceForChild(params).then(({ data }) => {
      if (data?.status === 'success') {
        addAlert({
          title: 'Цена обновлена',
        })
        onUpdate()
      } else {
        onError()
      }
    })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      <div className={classes.wrapper}>
        <div className={classes.directionDescriptionTitle}>Цена</div>
        <div className={classes.smallFieldWrapper}>
          <input
            className={classNames(
              classes.inputSmallWithTrailingIcon,
              classes.directionAdditionalDescriptionTitle,
            )}
            value={fieldValue}
            placeholder="0"
            type="number"
            onChange={handleChange}
          />
          <div className={classes.directionAdditionalDescriptionTitle}>
            руб.
          </div>
        </div>
      </div>
      {Number(fieldValue) !== defaultValue && (
        <div className={classes.saveIconButton} onClick={savePrice}>
          <IconDone />
        </div>
      )}
    </div>
  )
}

const PaymentIdentifierField = ({
  type,
  value,
  orderId,
  classId,
  userId,
  onUpdate = () => {},
}) => {
  const addAlert = useAddAlert()
  const defaultValue = value ?? ''
  const [fieldValue, setFieldValue] = useState(defaultValue)

  useEffect(() => {
    setFieldValue(defaultValue)
  }, [defaultValue])

  const savePaymentIdentifier = () => {
    const paymentIdentifier = String(fieldValue ?? '').trim()

    if (!paymentIdentifier) {
      addAlert({
        type: 'error',
        title: 'Payment ID не может быть пустым',
      })
      return
    }

    if (!/^[A-Za-z0-9]+$/.test(paymentIdentifier)) {
      addAlert({
        type: 'error',
        title: 'Payment ID может содержать только цифры и буквы',
      })
      return
    }

    const request =
      type === 'class'
        ? classApi.updatePaymentIdentifierForChild({
            class_id: classId,
            user_id: userId,
            payment_identifier: paymentIdentifier,
          })
        : directionOrdersApi.updatePaymentIdentifier({
            order_id: orderId,
            payment_identifier: paymentIdentifier,
          })

    request
      .then(({ data }) => {
        if (data?.status === 'success') {
          addAlert({ title: 'Payment ID обновлен' })
          onUpdate()
        } else {
          addAlert({
            type: 'error',
            title: 'Не удалось обновить Payment ID',
          })
        }
      })
      .catch(() => {
        addAlert({
          type: 'error',
          title: 'Не удалось обновить Payment ID',
        })
      })
  }

  return (
    <div className={classes.headerDirectionChipWrapper}>
      <div className={classes.wrapper}>
        <div className={classes.directionDescriptionTitle}>Pay ID</div>
        <div className={classes.smallFieldWrapper}>
          <input
            className={classNames(
              classes.inputSmallWithTrailingIcon,
              classes.paymentIdentifierInput,
              classes.directionAdditionalDescriptionTitle,
            )}
            value={fieldValue}
            placeholder="PID"
            type="text"
            onChange={(event) => setFieldValue(event.target.value)}
          />
        </div>
      </div>
      {fieldValue !== defaultValue && (
        <div className={classes.saveIconButton} onClick={savePaymentIdentifier}>
          <IconDone />
        </div>
      )}
    </div>
  )
}

function formatTimestampDate(timestamp) {
  const date = new Date(timestamp * 1000)

  const formattedDate = date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  return `${formattedDate}`
}

function formatLastActionTime(time) {
  if (!time) {
    return 'нет активности'
  }

  const date = new Date(time)

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}.${month}.${year}, ${hours}:${minutes}`
}

const StudentProfileFooter = ({ student, onAction, canEdit = true }) => {
  const settings = useSelector(store => store.settings)
  const userIdsAllowedToDeleteStudents = settings.userIdsAllowedToDeleteStudents
    ? JSON.parse(settings.userIdsAllowedToDeleteStudents)
    : []
  const selectEmployeesWhoAreAllowedDeleteStudents =
    settings.selectEmployeesWhoAreAllowedDeleteStudents === '1'

  const profile = useSelector(selectProfile)
  const canUseAdministrativeActions = getBaseRole(profile?.role) !== 'franchise-manager'
  const canChangeStudentStatus =
    canUseAdministrativeActions &&
    (userIdsAllowedToDeleteStudents.includes(profile.id) ||
      !selectEmployeesWhoAreAllowedDeleteStudents)

  const actions = canEdit
    ? [
        { label: 'Сохранить', action: 'save' },
        { label: 'Отмена', action: 'cancel' },
        ...(canUseAdministrativeActions
          ? [
              { label: 'Сбросить пароль', action: 'resetPassword' },
              { label: 'Авторизоваться', action: 'authorize' },
            ]
          : []),
        ...(canChangeStudentStatus
          ? [
              {
                label:
                  student?.status === 0 ? 'Разблокировать' : 'Заблокировать',
                action: 'block',
              },
            ]
          : []),
        ...(canChangeStudentStatus
          ? [
              {
                label: student?.status === 9 ? 'Восстановить' : 'Удалить',
                action: 'delete',
              },
            ]
          : []),
      ]
    : [{ label: 'Отмена', action: 'cancel' }]

  return (
    <div className={classes.footerContainer}>
      {actions.map(({ label, action }) => (
        <Button
          key={action}
          newDesign
          className={classNames(classes.footerButton, classes.truncateText)}
          onClick={() => onAction(action)}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}

const toBoolean = (value) => {
  return value === '1' || value === true
}

const getClassDirectionUniqueKey = (direction) =>
  [
    direction?.class_id ?? '',
    direction?.direction_id ?? direction?.direction?.id ?? '',
    direction?.group_id ?? direction?.group?.id ?? '',
    direction?.tariff_id ?? '',
  ].join(':')

const getUniqueClassDirections = (directions = []) => {
  const usedKeys = new Set()

  return directions.filter((direction) => {
    const key = getClassDirectionUniqueKey(direction)

    if (usedKeys.has(key)) {
      return false
    }

    usedKeys.add(key)
    return true
  })
}

const getDirectionSortingValue = (direction) => {
  const sorting = direction?.direction?.sorting

  if (sorting === null || sorting === undefined) {
    return Number.MAX_SAFE_INTEGER
  }

  return Number(sorting)
}

const compareDirectionOrdersByDirectionSorting = (direction1, direction2) => {
  const direction1Sorting = getDirectionSortingValue(direction1)
  const direction2Sorting = getDirectionSortingValue(direction2)

  if (direction1Sorting !== direction2Sorting) {
    return direction1Sorting - direction2Sorting
  }

  return Number(direction1?.direction_id ?? direction1?.direction?.id ?? 0) -
    Number(direction2?.direction_id ?? direction2?.direction?.id ?? 0)
}

const sortDirectionOrdersByDirectionSorting = (directions = []) =>
  [...directions].sort(compareDirectionOrdersByDirectionSorting)

const CourseInClass = ({
  name,
  tariffName,
  directionId,
  directionOrderId,
  group,
  studentId,
  isFree,
  getDirection,
  fetchClasses,
  seminarianName,
  userIdsAllowedToDeleteCourses,
  selectEmployeesWhoAreAllowedDeleteCourses,
  profile,
  handleDetachGroup,
  userClass,
  index,
  showPaymentWithoutRegistrationLinks = true,
  canManageStudentCourses = true,
  ktpGroupContent = null,
}) => {
  const isPaidClass = Boolean(userClass?.one_pay)

  return (
    <div
      className={classNames(
        classes.directionCourseItem,
        ktpGroupContent && classes.directionCourseItemWithKtp,
      )}
      key={index}
    >
      <div
        className={classNames(
          classes.directionTableCell,
          classes.directionCourseTableItem,
          !isFree && classes.directionCourseLinkCell,
        )}
      >
        <div className={classes.directionCourseLinkCellContent}>
          <div>{name}</div>
          {showPaymentWithoutRegistrationLinks && !isFree && !isPaidClass && (
            <PaymentWithoutRegistrationLinkField
              link={getPaymentWithoutRegistrationOrderLink(
                studentId,
                directionOrderId,
              )}
            />
          )}
        </div>
      </div>
      <div
        className={classNames(
          classes.directionTableCell,
          classes.directionCourseTableItem,
        )}
      >
        {tariffName}
      </div>
      <div
        className={classNames(
          // classes.directionTableCell,
          classes.directionCourseTableItem,
        )}
      >
        {canManageStudentCourses ? (
          <ChangeGroupCell
            className={classes.directionTableChangeGroupCell}
            directionId={directionId}
            directionOrderId={directionOrderId}
            studentId={studentId}
            selectedGroup={group}
            refetchData={() => {
              getDirection()
              fetchClasses()
            }}
          />
        ) : (
          group?.name ?? '-'
        )}
      </div>
      {ktpGroupContent && (
        <div
          className={classNames(
            classes.directionTableCell,
            classes.directionCourseKtpCell,
          )}
        >
          {ktpGroupContent}
        </div>
      )}
      <div
        className={classNames(
          classes.directionTableCell,
          classes.directionCourseTableItem,
        )}
      >
        {seminarianName}
      </div>
      <div className={classes.directionCourseActions}>
      {canManageStudentCourses &&
        (userIdsAllowedToDeleteCourses.includes(profile.id) ||
          !selectEmployeesWhoAreAllowedDeleteCourses) && (
        <div
          onClick={() => {
            handleDetachGroup(group, userClass)
          }}
          className={classNames(classes.secondaryIcon, classes.deleteDirection)}
        >
          <IcoRemove />
        </div>
      )}
      </div>
    </div>
  )
}

export default EditStudentModal
